{
  "app": {
    "title": "Lodestar",
    "subtitle": "Атлас релокации — найди, где будешь жить"
  },
  "brand": {
    "tagline": "АТЛАС РЕЛОКАЦИИ"
  },
  "home": {
    "meta": {
      "title": "Lodestar — найди страну, в которой будешь жить",
      "description": "Атлас осознанной релокации. Девять вопросов, оценка 39 стран по десяти измерениям: климат, стоимость, налоги, виза, медицина, язык, безопасность, работа, семья, банкинг. Открытые данные. Без регистрации."
    },
    "header": {
      "atlas": "Атлас",
      "guide": "Руководство",
      "howTo": "Инструкция",
      "map": "Карта мира",
      "methodology": "Метод"
    },
    "hero": {
      "title": "Найди место, где тебе будет хорошо.",
      "sub": "Перестань ходить по кругу. Девять вопросов, 31 страна, открытые данные — узнаешь, куда ты реально подходишь.",
      "tagline": "Тридцать стран. Десять измерений жизни. Две минуты.",
      "italyOnly": "Детальная карта по комунам — только Италия · Квиз — 31 страна",
      "primaryCta": "Найти мой вариант",
      "secondaryCta": "Или открыть каталог из 39 стран",
      "preview": {
        "label": "Пример рейтинга — ответы перебираются",
        "caption": "Основано на «{{preset}}»",
        "tryYours": "Попробуй свой →"
      },
      "presets": {
        "alpine_eu": "альпийский климат, паспорт ЕС, низкие налоги",
        "tropical_dn": "тропики, удалёнка",
        "med_coast": "побережье Средиземного, семья",
        "northern_jobs": "северная Европа, работа",
        "sun_cost": "солнце, экономно",
        "city_family": "большой город, семья в приоритете"
      }
    },
    "trust": {
      "label": "Источники"
    },
    "taste": {
      "title": "Попробуй без регистрации.",
      "sub": "Выбери, что важнее всего. Мгновенно покажем тройку стран.",
      "question": "Что важнее всего?",
      "basedOn": "По «{{dim}}»",
      "takeFull": "Пройди полный тест, чтобы увидеть 31 страну по всем твоим приоритетам →",
      "empty": "Выбери измерение выше, чтобы увидеть тройку.",
      "dim": {
        "climate": "Климат",
        "cost": "Стоимость",
        "visa": "Виза",
        "healthcare": "Медицина",
        "safety": "Безопасность",
        "tax": "Налоги"
      }
    },
    "how": {
      "title": "Как это работает",
      "s1": {
        "n": "01",
        "title": "Сформулируй, что не готов потерять",
        "body": "Климат, бюджет, паспорт, семья — и твои жёсткие ограничения. Девять вопросов, две минуты."
      },
      "s2": {
        "n": "02",
        "title": "Ограничения отсекают, остальное ранжируется",
        "body": "Страны, которые не подходят принципиально — виза, климат, банки — исключаются сразу, а не просто получают штраф."
      },
      "s3": {
        "n": "03",
        "title": "Уходишь с конкретным направлением",
        "body": "Топ-страны с оценками и человеческими объяснениями. Карта Италии — когда будешь готов исследовать детально."
      }
    },
    "pillars": {
      "title": "Зачем переезжают сейчас",
      "subtitle": "Чаще всего переезд — это не одна причина, а две-три, наложенные одна на другую. Квиз разберётся, какая из них для тебя важнее.",
      "tax": {
        "title": "Налоги и финансы",
        "body": "Налоговое резидентство со спецрежимами, освобождение от worldwide-tax, оптимизация. Где деньги растут, а не просто хранятся.",
        "link": "Посмотреть наследника NHR в Португалии"
      },
      "career": {
        "title": "Карьера и работа",
        "body": "Рост в IT, спонсорский найм, путь для квалифицированных мигрантов. Где строить ближайшие 5–10 лет, а не только лайфстайл на год.",
        "link": "Посмотреть, что готовится"
      },
      "family": {
        "title": "Семья и лайфстайл",
        "body": "Школы, медицина, повседневный ритм. Форма той жизни, к которой переезжаешь, а не от которой убегаешь.",
        "link": "Открыть Италию"
      },
      "independence": {
        "title": "Независимость",
        "body": "Удалёнка, фриланс, финансовая независимость. Когда доход не привязан к стране — но жить где-то всё равно надо, и лучше там, где хочется.",
        "link": "Открыть ОАЭ"
      },
      "bridge": "Выбери пиллар, который ближе, или пройди квиз — мы сами найдём веса."
    },
    "dims": {
      "title": "Десять измерений жизни.",
      "sub": "Каждое — 0–10 на открытых данных.",
      "card": {
        "climate": {
          "title": "Климат",
          "source": "Open-Meteo · 1991–2020"
        },
        "cost": {
          "title": "Стоимость",
          "source": "livingcost.org · 2026"
        },
        "tax": {
          "title": "Подоходный налог",
          "source": "OECD · 2024"
        },
        "property_tax": {
          "title": "Налог на недвижимость",
          "source": "Lodestar KB · 2026-Q2",
          "range": "ежегодный + покупка + прирост капитала сводятся в тир"
        },
        "visa": {
          "title": "Виза",
          "source": "Гос. порталы · 2024"
        },
        "healthcare": {
          "title": "Медицина",
          "source": "WHO UHC · 2023"
        },
        "safety": {
          "title": "Безопасность",
          "source": "IEP GPI · 2026"
        },
        "language": {
          "title": "Язык",
          "source": "EF EPI · 2025"
        },
        "jobs": {
          "title": "Работа / интернет",
          "source": "Ookla · 2024"
        },
        "family": {
          "title": "Семья",
          "source": "UNESCO + IB · 2024"
        },
        "banking": {
          "title": "Банкинг",
          "source": "Wise · FATF · 2024"
        }
      },
      "rangeExample": "напр. {{high}} {{highScore}} · {{low}} {{lowScore}}"
    },
    "atlas": {
      "title": "Тридцать стран. Пять регионов. Четыре уровня глубины данных.",
      "tierT0": "T0 — Италия как пионер. Гранулярные данные по комуне, 8000 мест, живая карта.",
      "tierT1": "T1 — топ-направления. Метрики на уровне страны. Карты выкатываем в ближайших кварталах.",
      "tierT2T3": "T2 / T3 — ещё двадцать три. Подпишись на уведомление о появлении страны.",
      "browseAll": "Смотреть все 39 стран →",
      "guideCta": "Как пользоваться картой →",
      "guideBadge": "Гид →"
    },
    "map": {
      "eyebrow": "Интерактивная карта",
      "title": "Смотри изнутри — место за местом",
      "sub": "Когда страна выбрана — заходи глубже: фильтруй по климату, стоимости жизни, здравоохранению, безопасности. Пинуй места, сравнивай бок о бок, уточняй у AI. Сейчас доступна Италия — остальные страны на подходе.",
      "screenshotAlt": "Интерактивная карта с фильтрами и данными по населённым пунктам — пример: Италия",
      "cta": "Попробовать на примере Италии →",
      "ctaWorld": "Открыть карту мира",
      "feat": {
        "filters": {
          "title": "Слой за слоем",
          "body": "Климат-нормы, стоимость жизни, здравоохранение, интернет — переключай слои данных и ищи то, что важно именно тебе."
        },
        "details": {
          "title": "Профиль населённого пункта",
          "body": "Кликни на любую точку — полная статистика, AI-контекст и соседние альтернативы, которые стоит рассмотреть."
        },
        "compare": {
          "title": "Шорт-лист и сравнение",
          "body": "Сохраняй места в шорт-лист и сравнивай их бок о бок, прежде чем планировать поездку."
        }
      }
    },
    "method": {
      "title": "О методе —",
      "body1": "Каждая страна оценивается по открытым данным: климат-нормы 1991–2020 от Open-Meteo, налоги — OECD, владение английским — EF EPI, безопасность — Institute for Economics & Peace.",
      "body2": "Веса берём геометрически — одно слабое измерение нельзя «уравновесить» сильным. Жёсткие ограничения (нет Шенгена, нет банкинга для твоего паспорта) исключают страну, а не штрафуют её.",
      "body3": "Match score — это говорит наша модель, не вердикт. Смотри карту, чтобы посмотреть ближе.",
      "link": "Полный метод →",
      "propertyTaxLabel": "Новое: данные по налогу на недвижимость",
      "propertyTaxBody": "Помимо подоходного налога, карточка каждой страны теперь содержит верифицированный уровень налогообложения недвижимости (ежегодный налог на владение + налог при покупке + налог на прирост капитала + налог на богатство). Источники: OECD, EU Taxes in Europe Database, Global Property Guide и KPMG. Срок жизни данных — ~12 месяцев: налоговые кодексы меняются с началом фискального года, поэтому мы перепроверяем ежеквартально."
    },
    "faq": {
      "title": "Вопросы",
      "q1": "Для кого это?",
      "a1": "Для тех, кто всерьёз рассматривает переезд за рубеж — удалёнщики, семьи, пенсионеры, предприниматели. Ты уже знаешь, что хочешь уехать — просто ещё не нашёл место, где будет по-настоящему хорошо.",
      "q2": "Чем это отличается от вопроса в ChatGPT?",
      "a2": "ChatGPT даёт мнение. Мы даём оценку по данным: нормы климата, таблицы OECD, индекс ВОЗ по медицине, скорости Ookla. У каждой цифры есть источник. Тест учитывает твои компромиссы и ранжирует по ним — без дежурного «Португалия отлично подходит».",
      "q3": "Как считается рейтинг?",
      "a3": "Десять измерений (климат, стоимость, налоги, виза, медицина, безопасность, язык, интернет, семья, банкинг), каждое — 0–10 из открытых данных. Комбинируем геометрически: одно слабое измерение действительно важно, его не усреднить. Жёсткие ограничения исключают страну целиком.",
      "q4": "Будут ли детальные карты других стран как у Италии?",
      "a4": "Да. Италия — наш пилот: 8000 мест, данные на уровне комуне — климат, цены, интернет, демография. Следующие — Португалия, Испания, ОАЭ. Подпишись на конкретную страну в атласе.",
      "q5": "Данные актуальные?",
      "a5": "Климат-нормы — 1991–2020 (30-летний стандарт WMO — самая репрезентативная база). Налоги, визы, язык — обновляем ежегодно. Каждая цифра показывает источник и год — ничего не спрятано."
    },
    "footer": {
      "ctaTitle1": "Ты уже знаешь, что хочешь переехать.",
      "ctaTitle2": "Осталось найти куда.",
      "ctaPrimary": "Найти мой вариант",
      "ctaSecondary": "Или открыть каталог из 39 стран →",
      "rights": "© 2026 Lodestar",
      "privacy": "Приватность",
      "terms": "Условия",
      "partners": "Для консультантов",
      "github": "GitHub",
      "tagline": "Международный навигатор по релокации — квиз, атлас на 39 стран, журналистские гиды.",
      "guidesTitle": "Гиды по странам",
      "checklist": "Чеклист",
      "allCountries": "Все 39 стран →",
      "exploreTitle": "Разделы",
      "quiz": "Пройти квиз",
      "topics": "По темам",
      "guideLink": "Инструкция по сайту",
      "worldMap": "Карта мира",
      "countryMap": "Интерактивная карта: {{country}}",
      "newsletter": {
        "label": "Ежемесячный дайджест",
        "copy": "Одно вдумчивое письмо в месяц — новые страны, обновления данных, материалы о релокации. Без спама, отписка в один клик.",
        "placeholder": "ты@example.com",
        "submit": "Подписаться",
        "sending": "Отправляем…",
        "confirm": "Письмо с подтверждением уже в почте — пока не нажмёте кнопку в нём, ничего не придёт.",
        "failed": "Подписка не оформилась — адрес не сохранён. Попробуйте ещё раз."
      },
      "refund": "Политика возврата",
      "report": "Отчёт о релокации"
    }
  },
  "worldMap": {
    "meta": {
      "title": "Карта мира — атлас Lodestar",
      "description": "31 направление релокации на одной карте. Открыть интерактивную карту Италии или Испании, прочитать полные гиды (Италия, Португалия, Испания, ОАЭ) или перейти в каталог остальных стран. Кликни на любую закрашенную страну, чтобы провалиться внутрь."
    },
    "eyebrow": "Quiet Atlas — карта мира",
    "title": "Тридцать направлений на одной карте.",
    "lede": "Каждая страна каталога, окрашена по тому, что готово к прочтению. Кликни на Италию или Испанию, чтобы открыть интерактивную карту по муниципалитетам. Кликни на Португалию или ОАЭ, чтобы открыть полный гид. Кликни на любую другую закрашенную страну, чтобы перейти в атлас.",
    "regionAria": "Карта мира с направлениями релокации",
    "attribution": "Границы: Natural Earth через world-atlas TopoJSON. Карта для навигации, не для дипломатических заявлений.",
    "legend": {
      "aria": "Легенда карты",
      "title": "Легенда статусов",
      "liveMap": "Интерактивная карта",
      "fullGuide": "Полный гид",
      "inRoster": "В атласе (гид готовится)",
      "notInRoster": "Не в нашем списке",
      "tip": "Кликни на закрашенную страну"
    },
    "popup": {
      "liveMap": "Интерактивная карта + полный гид",
      "fullGuide": "Полный гид готов",
      "inRoster": "В атласе, полный гид готовится",
      "openMap": "Открыть интерактивную карту →",
      "readGuide": "Читать гид",
      "openAtlas": "Открыть атлас →"
    },
    "strip": {
      "liveMap": {
        "label": "Интерактивная карта",
        "body": "Заходи внутрь тысяч муниципалитетов: климат, цены, интернет, демография.",
        "ctaCountry": "Открыть карту: {{country}} →"
      },
      "guides": {
        "label": "Полные гиды",
        "title": "Италия, Португалия, Испания, ОАЭ",
        "body": "Хаб + 12 глав по стране, на EN и RU. Журналистика, не википедийная свалка.",
        "cta": "Открыть гиды →"
      },
      "roster": {
        "label": "В атласе, гиды следующими",
        "titleSuffix": "стран",
        "body": "Уже в квизе и каталоге. Полный гид готовится в следующих волнах.",
        "cta": "Перейти к атласу →"
      },
      "quiz": {
        "label": "Не знаешь, с чего начать?",
        "title": "Пройди 2-минутный квиз",
        "body": "Девять вопросов, 31 страна оценена, ранжированный матч. Потом возвращайся в карту.",
        "cta": "Начать квиз →"
      }
    }
  },
  "quiz": {
    "meta": {
      "title": "Тест на страну для переезда — 39 направлений",
      "description": "Десять вопросов о климате, бюджете, визах и семье — и вы получаете ранжированный список стран с оценкой по десяти измерениям жизни. Бесплатно, без регистрации."
    },
    "landing": {
      "title": "Где тебе будет хорошо?",
      "subtitle": "Расскажи, как хочешь жить. Мы подберём страну за две минуты.",
      "tagline": "Тридцать стран, оценённых по десяти измерениям жизни.",
      "startCta": "Найти мой вариант",
      "skipCta": "Открыть карту Италии",
      "comingSoon": "Скоро",
      "samplesLabel": "Три места — для примера"
    },
    "q": {
      "horizon": {
        "label": "Когда планируешь переезд?",
        "opt": {
          "now": "В этом году — активно планирую",
          "soon": "Через 2–5 лет",
          "next_year": "Через 1–2 года",
          "explore": "Просто смотрю, дата не определена",
          "already": "Уже переехал(а)"
        }
      },
      "passport": {
        "label": "Какой у тебя паспорт (паспорта)?",
        "description": "Используется для подсветки визовых и банковских ограничений для держателей паспортов СНГ. Россия / Беларусь / Украина указаны отдельно, потому что с 2022 года страны-хозяева очень по-разному относятся к каждому из них в вопросах банков, недвижимости и выдачи документов.",
        "opt": {
          "eu": "ЕС (любая страна)",
          "anglo": "США / Великобритания / Австралия / Канада / Новая Зеландия",
          "ru": "Паспорт РФ",
          "by": "Паспорт Беларуси",
          "ua": "Паспорт Украины",
          "other": "Другое (Азия, ЛатАм, Африка, Ближний Восток)"
        }
      },
      "visa_pathway": {
        "label": "Какие визовые маршруты тебе подходят? (можно несколько)",
        "description": "Опционально. Отметь всё, что реально может сработать. Мы повысим в рейтинге страны, где эти пути есть, и аккуратно понизим страны, где ни одного из выбранных маршрутов нет.",
        "opt": {
          "digital_nomad": "Виза цифрового кочевника",
          "freelance_self_employed": "Виза фрилансера / самозанятого",
          "golden_investor": "Инвесторская виза (обычно от €250 тыс.)",
          "family_reunion": "Воссоединение семьи",
          "ancestry": "Гражданство по происхождению",
          "work_sponsor": "Рабочая виза от работодателя",
          "student_to_perm": "Учёба с переходом к ВНЖ",
          "refugee_protection": "Беженство / временная защита",
          "unknown_exploring": "Пока не знаю — изучаю варианты"
        }
      },
      "climate": {
        "label": "Какой климат тебе комфортен?",
        "opt": {
          "alps": "Альпы / горы",
          "mediterranean": "Средиземноморский",
          "continental": "Континентальный",
          "tropical": "Тёплое побережье / тропики",
          "northern": "Северный / прохладный",
          "any": "Без предпочтений"
        }
      },
      "urban_density": {
        "label": "Где идеально жить?",
        "description": "Тип места определяет стоимость жизни, доступность работы и то, насколько в быту понадобится местный язык.",
        "opt": {
          "capital": "Столица или крупный город (от 1 млн)",
          "mid_city": "Средний город (100–500 тыс.)",
          "town": "Небольшой город или деревня (до 50 тыс.)",
          "coastal": "Побережье (любой размер)"
        },
        "help": {
          "capital": "Как Берлин или Мадрид — больше всего работы и проще с английским, лучший транспорт и сервис, но аренда ~на 30% выше средней по стране.",
          "mid_city": "Как Порту или Гранада — вся городская инфраструктура и небольшое международное комьюнити, заметно дешевле столицы. Оптимальный выбор для большинства.",
          "town": "Тише и дешевле всего, крепкое местное сообщество — но нужен местный язык, а за работой, авиарейсами и специалистами придётся ездить.",
          "coastal": "Море рядом при любом размере — мягче климат, неспешный летне-курортный ритм. Как Валенсия или Ницца; вид на море обычно добавляет к аренде."
        }
      },
      "budget": {
        "label": "Бюджет на аренду в месяц",
        "description": "Примерная аренда квартиры для семьи (2-3 комнаты) в желаемом городе, в евро в месяц. Без коммуналки и еды. Можно пропустить."
      },
      "priorities": {
        "label": "Что важно в повседневной жизни? (до 3)",
        "opt": {
          "safety": "Безопасность",
          "healthcare": "Медицина",
          "schools": "Школы",
          "transport": "Транспорт",
          "nature": "Природа и активный отдых",
          "ru-community": "Русскоязычная диаспора рядом",
          "mountain_sports": "Горы / лыжи",
          "water_sports": "Море / водный спорт"
        }
      },
      "income": {
        "label": "Откуда доход?",
        "opt": {
          "remote": "Удалённая работа",
          "local": "Местная работа",
          "business": "Свой бизнес",
          "passive": "Пассивный доход (дивиденды, аренда, пенсия)"
        }
      },
      "income_amount": {
        "label": "Сколько примерно в месяц?",
        "description": "Опционально. Большинство виз цифрового кочевника требуют подтверждение дохода от €2.5–3k/мес — без этого ответа мы не объясним, почему DN-страны могут быть недостижимы.",
        "opt": {
          "lt1500": "До €1 500 / мес",
          "1500to3000": "€1 500 – €3 000",
          "3000to6000": "€3 000 – €6 000",
          "gt6000": "Свыше €6 000"
        }
      },
      "tax_residency_intent": {
        "label": "Как планируешь платить налоги после переезда?",
        "description": "Опционально. От того, где ты платишь налоги, зависит, в какой стране ты реально сэкономишь. Не разобрался — выбери последний вариант, мы всё равно подберём подходящие страны.",
        "opt": {
          "break_origin": "Полностью выйти из налоговой системы родной страны",
          "keep_origin": "Продолжать платить налоги дома (напр., гражданин США)",
          "dual": "Не уверен — возможно, буду связан с двумя странами",
          "treaty_minimize": "Не платить налоги дважды — через соглашение об избежании",
          "unsure": "Ещё не думал об этом"
        }
      },
      "career_intent": {
        "label": "Нужно ли вам будет зарабатывать на месте после переезда?",
        "description": "Опционально. Большинство переезжают сначала ради жизни, а доход решают позже — это лишь подсказывает, вплетать ли в ваш план местный {{term:labour-market}} и консультацию по трудоустройству.",
        "opt": {
          "primary": "Да — буду искать работу на месте",
          "eventual": "Возможно позже, не сразу",
          "none": "Нет — доход не зависит от местной работы"
        },
        "help": {
          "primary": "Найти работу на месте — ключевая часть переезда. Учтём рынок труда страны и то, насколько в нём можно работать на английском, — а когда будете готовы, сведём вас с консультантом по релокации и трудоустройству.",
          "eventual": "Переезжаете по другим причинам, но через год-два, возможно, захотите искать работу. Покажем рынок труда как контекст, а не как фильтр.",
          "none": "Удалёнка, фриланс, сбережения, пенсия или поддержка семьи. Местный рынок труда не влияет на ваш выбор."
        }
      },
      "family": {
        "label": "Кто переезжает с тобой?",
        "description": "Отметь всех, кто едет. Влияет на приоритеты: школы, педиатрия, правила ввоза питомцев.",
        "opt": {
          "solo": "Только я",
          "partner": "Супруг / партнёр",
          "kids-preschool": "Дети до 7 лет (детсад)",
          "kids-school": "Дети 7-17 лет (школа)",
          "pets": "Питомцы (кот / собака)"
        }
      },
      "languages": {
        "label": "Языки, на которых говоришь или готов учить",
        "opt": {
          "en": "Английский",
          "it": "Итальянский",
          "es": "Испанский",
          "de": "Немецкий",
          "fr": "Французский",
          "pt": "Португальский",
          "any": "Готов любой",
          "ru-only": "Только родной язык (без английского/местного)"
        }
      },
      "dealbreakers": {
        "label": "Что точно неприемлемо?",
        "description": "Опционально. Отметь, чего хочешь избежать.",
        "opt": {
          "hot-summer": "Жара выше 35°C",
          "snow": "Снежная зима",
          "humidity": "Высокая влажность",
          "earthquakes": "Землетрясения",
          "complex-visa": "Сложный ВНЖ",
          "expensive-healthcare": "Дорогая медицина"
        }
      },
      "buy_property": {
        "label": "Планируешь купить недвижимость?",
        "description": "Опционально. Покупка включает вторую очередь налогов (ежегодный + покупка + прирост капитала) — это меняет, какие страны влезают в бюджет.",
        "opt": {
          "yes": "Да — в течение нескольких лет",
          "no": "Нет — только аренда",
          "unsure": "Пока не решил"
        }
      },
      "ties": {
        "label": "К каким из этих стран у тебя уже есть связь?",
        "description": "Семья или друзья там, жил(а) раньше, знаешь язык, ездишь часто — любая значимая связь. Выбери все подходящие. Пропусти, если начинаешь с нуля.",
        "opt": {
          "AE": "🇦🇪 ОАЭ",
          "AL": "🇦🇱 Албания",
          "AR": "🇦🇷 Аргентина",
          "BR": "🇧🇷 Бразилия",
          "CA": "🇨🇦 Канада",
          "CL": "🇨🇱 Чили",
          "CO": "🇨🇴 Колумбия",
          "CR": "🇨🇷 Коста-Рика",
          "CY": "🇨🇾 Кипр",
          "CZ": "🇨🇿 Чехия",
          "DE": "🇩🇪 Германия",
          "EE": "🇪🇪 Эстония",
          "ES": "🇪🇸 Испания",
          "FR": "🇫🇷 Франция",
          "GB": "🇬🇧 Великобритания",
          "GE": "🇬🇪 Грузия",
          "GR": "🇬🇷 Греция",
          "HR": "🇭🇷 Хорватия",
          "HU": "🇭🇺 Венгрия",
          "ID": "🇮🇩 Индонезия",
          "IE": "🇮🇪 Ирландия",
          "IT": "🇮🇹 Италия",
          "ME": "🇲🇪 Черногория",
          "MT": "🇲🇹 Мальта",
          "MU": "🇲🇺 Маврикий",
          "MX": "🇲🇽 Мексика",
          "MY": "🇲🇾 Малайзия",
          "NL": "🇳🇱 Нидерланды",
          "PA": "🇵🇦 Панама",
          "PL": "🇵🇱 Польша",
          "PT": "🇵🇹 Португалия",
          "PY": "🇵🇾 Парагвай",
          "RS": "🇷🇸 Сербия",
          "SG": "🇸🇬 Сингапур",
          "TH": "🇹🇭 Таиланд",
          "TR": "🇹🇷 Турция",
          "UY": "🇺🇾 Уругвай",
          "VN": "🇻🇳 Вьетнам",
          "ZA": "🇿🇦 ЮАР"
        }
      },
      "family_children_count": {
        "label": "Сколько детей?",
        "description": "Чтобы цифры расходов дальше в отчёте отражали твою семью, а не усреднённую.",
        "opt": {
          "1": "1 ребёнок",
          "2": "2 ребёнка",
          "3plus": "3 и более"
        }
      }
    },
    "budget": {
      "bucket": {
        "lt500": "До 500 €",
        "500to1000": "500–1000 €",
        "1000to2000": "1000–2000 €",
        "gt2000": "От 2000 €"
      },
      "skip": "Не хочу указывать"
    },
    "nav": {
      "back": "Назад",
      "next": "Далее",
      "skip": "Пропустить",
      "finish": "Показать результаты"
    },
    "hint": {
      "selectUpTo": "Выбери до {{n}}",
      "selectAll": "Выбери все подходящие"
    },
    "progress": {
      "stepOf": "Шаг {{current}} из {{total}}",
      "timeLeft": "~{{minutes}} мин",
      "timeLeftSoon": "~1 мин",
      "timeLeftEnd": "Последний вопрос",
      "topic": {
        "horizon": "Горизонт",
        "passport": "Паспорт",
        "visa_pathway": "Путь к визе",
        "climate": "Климат",
        "urban_density": "Где",
        "budget": "Бюджет",
        "priorities": "Приоритеты",
        "income": "Доход",
        "income_amount": "Сумма дохода",
        "tax_residency_intent": "Налоговое резидентство",
        "career_intent": "Работа",
        "family": "Семья",
        "languages": "Языки",
        "dealbreakers": "Стоп-факторы",
        "ties": "Связи",
        "buy_property": "Покупка жилья?"
      }
    },
    "interstitial": {
      "title": "Предварительная тройка",
      "subtitle": "По твоим {{answered}} ответам пока ведут эти три страны. Несколько следующих вопросов уточнят и пересортируют список.",
      "subtitleNone": "Ответь ещё пару вопросов — здесь появится тройка лидеров.",
      "rankPrefix": "#",
      "continue": "Продолжить"
    },
    "loading": {
      "title": "Анализируем 31 страну по 47 параметрам…",
      "subtitle": "Собираем твой персональный рейтинг"
    },
    "result": {
      "matchPercent": "{{percent}}% совпадения",
      "blockerLabel": "Учти:",
      "comingSoon": "Карта скоро",
      "title": "Лучшие совпадения",
      "subtitle": "На основе {{answersCount}} ответов · {{dimensions}} измерений · оценено {{countriesCount}} стран",
      "subtitleWithMap": "На основе {{answersCount}} ответов — фильтры уже загружены в карту {{name}}.",
      "matchLabel": "Совпадение",
      "rank": "#{{rank}} из {{total}} стран",
      "whyFits": "Почему подходит",
      "consider": "Учти",
      "sources": "Источники: ISTAT · 2024 · Open-Meteo · 1991-2020 · OECD · 2024",
      "openMap": "Открыть карту {{country}} →",
      "notify": "Уведомить, когда появится",
      "notifyContext": "Интерактивная карта регионов · в разработке. Также пришлём одноразовую ссылку для входа — заходите к своему квизу с любого устройства.",
      "notifyPlaceholder": "твой@email.com",
      "notifySubmit": "Уведомить",
      "notifySuccess": "Записали — проверьте почту: одноразовая ссылка для входа, потом сообщим, когда {{country}} будет готова.",
      "nextSteps": "Чеклист переезда и следующие шаги",
      "retake": "Пройти заново",
      "share": "Поделиться",
      "shareCopied": "Ссылка скопирована",
      "excluded": "Исключено ({{count}})",
      "unscored": "Скоро ({{count}})",
      "expand": "Показать детали",
      "collapse": "Скрыть детали",
      "noMatches": "Ничего не прошло жёсткие фильтры. Попробуй убрать часть стоп-факторов.",
      "scoreBreakdownAria": "Разбор скоринга",
      "componentTooltip": "{{dim}}: {{component}} × вес {{weight}}",
      "dim": {
        "climate": "Климат",
        "cost": "Стоимость",
        "tax": "Налоги",
        "visa": "ВНЖ",
        "healthcare": "Медицина",
        "safety": "Безопасность",
        "language": "Язык",
        "jobs": "Работа",
        "family": "Семья",
        "banking": "Банкинг"
      },
      "reason": {
        "climate": "Климат соответствует предпочтениям",
        "cost": "Бюджет покрывает страну",
        "tax": "Дружелюбный налоговый режим",
        "visa": "Простой путь к ВНЖ",
        "healthcare": "Сильная универсальная медицина",
        "safety": "Высокий уровень безопасности",
        "language": "Низкий языковой барьер",
        "jobs": "Хороший интернет и удалёнка",
        "family": "Удобно для семьи и школ",
        "banking": "Банки работают с твоим паспортом"
      },
      "seeRegions": "Топ регионов для твоего профиля",
      "openFullMap": "Или открыть всю карту",
      "personaWhyFits": "Почему это место тебе подходит",
      "passportNotice": {
        "label": {
          "cautious": "Внимание для твоего паспорта",
          "restrictive": "Серьёзные ограничения для твоего паспорта",
          "hostile": "Страна фактически закрыта для твоего паспорта"
        }
      },
      "blocker": {
        "climate": "Климат может не подходить",
        "cost": "Стоимость жизни давит на бюджет",
        "tax": "Налоговая нагрузка высокая",
        "visa": "Путь к ВНЖ непростой",
        "healthcare": "Медицина ниже среднего",
        "safety": "Безопасность ниже сопоставимых стран",
        "language": "Высокий языковой барьер",
        "jobs": "Слабый рынок работы / интернет",
        "family": "Слабая инфраструктура для семьи",
        "banking": "Банки ограничены для твоего паспорта",
        "detail": {
          "languageRuOnly": "ты выбрал «только родной язык» — для долгосрочного ВНЖ обычно нужен уровень B1+ местного языка",
          "languageEnOnly": "ты выбрал только английский — для получения вида на жительство обычно нужен базовый местный язык",
          "visaCis": "Паспорт СНГ (РФ/РБ/Украина): большинство маршрутов требуют спонсора или инвестор-визы",
          "visaOther": "твой паспорт ограничивает безвизовые варианты — обычно нужен спонсор или работодатель",
          "costLowBudget": "твой бюджет в нижней корзине (≤ €1000/мес)",
          "taxRemote": "ты отметил удалённую работу или свой бизнес — налоговое резидентство добавляет сложности",
          "bankingCis": "Паспорт СНГ (РФ/РБ/Украина): открытие счёта обычно блокируется проверками санкционных списков",
          "healthcarePrio": "ты отметил медицину в приоритетах",
          "familyKids": "ты указал школьных детей — важен местный язык и наличие мест в школе",
          "climateDealbreaker": "эта страна попадает под стоп-фактор, который ты выбрал"
        },
        "withContext": "{{generic}} — {{detail}}",
        "humidity_above_70": "Высокая влажность круглый год",
        "seismic_country": "Сейсмически активный регион",
        "warm_summer": "Тёплое лето (30-35°C)",
        "low_english_for_ru_only": "Слабый английский для русскоязычных",
        "moderate_english_for_ru_only": "Средний английский для русскоязычных",
        "banking_closed_for_ru": "Банки закрыты или ограничены для РФ паспорта",
        "no_digital_nomad_or_freelance_path": "Нет визы для удалёнщиков и фрилансеров",
        "healthcare_below_70": "Медицина ниже порога",
        "summer_above_35c": "Лето выше 35°C",
        "winter_below_0c": "Зима ниже 0°C",
        "cost_exceeds_low_budget": "Стоимость выше твоего бюджета",
        "passport_hostile_ru": "Страна фактически закрыта для паспорта РФ (отказы банков и нотариусов)",
        "passport_hostile_by": "Страна фактически закрыта для паспорта РБ (отказы банков и нотариусов)",
        "passport_hostile_ua": "Страна фактически закрыта для украинского паспорта",
        "passport_restrictive_ru": "Существенные сложности для паспорта РФ (банки и документы)",
        "passport_restrictive_by": "Существенные сложности для паспорта РБ (банки и документы)",
        "passport_restrictive_ua": "Существенные сложности для украинского паспорта",
        "passport_cautious_ru": "Небольшие сложности для паспорта РФ (доп. проверки)",
        "passport_cautious_by": "Небольшие сложности для паспорта РБ (доп. проверки)",
        "passport_cautious_ua": "Небольшие сложности для украинского паспорта",
        "partial_snow_risk": "В части регионов бывает снежная зима",
        "fallback": "Исключено вашими фильтрами"
      },
      "adjust": {
        "title": "Хочешь подкрутить приоритеты?",
        "description": "Меняй важность каждого фактора и рейтинг пересчитается на лету.",
        "reset": "Сбросить",
        "sliderAria": "Вес «{{dim}}»: {{value}}",
        "apply": "Применить",
        "pending": "Есть несохранённые правки — нажми «Применить», чтобы пересчитать рейтинг.",
        "synced": "Рейтинг актуален."
      },
      "allRanked": "Ещё {{count}} стран в рейтинге",
      "climate": {
        "julLabel": "Июль макс",
        "janLabel": "Январь мин",
        "rangeNote": "(по регионам)"
      },
      "heroTitle": "{{flag}} {{name}} — твой лучший вариант.",
      "heroTitleGeneric": "Твои варианты готовы.",
      "heroTitlePlural": "Несколько вариантов идут очень близко.",
      "persona": {
        "title": "Что ты указал в квизе",
        "aria": "Твои ответы из квиза"
      },
      "podium": {
        "title": "Твой топ-3",
        "aria": "Топ-3 страны кратко"
      },
      "propertyTax": {
        "label": "Налог на недвижимость"
      }
    },
    "scenarios": {
      "saveButton": "Сохранить этот рейтинг",
      "savePlaceholder": "напр. Для номада",
      "saveConfirm": "Сохранить",
      "saveCancel": "Отмена",
      "savedAs": "Сохранено: «{{name}}»",
      "sectionTitle": "Сохранённые рейтинги",
      "load": "Загрузить",
      "delete": "Удалить",
      "savedOn": "Сохранено {{date}}",
      "topMatch": "Топ: {{flag}} {{name}} · {{percent}}%",
      "compare": "Сравнить",
      "compareClose": "Список",
      "atLimit": "Сохранено {{count}}/{{max}} — следующее заменит старое"
    },
    "emailGate": {
      "label": "Результаты готовы",
      "headline": "{{flag}} {{name}}",
      "matchLine": "{{percent}}% совпадение",
      "restLabel": "+ ещё {{count}} страны в твоём рейтинге",
      "formTitle": "Сохрани и открой полный рейтинг",
      "formSub": "Пришлём одноразовую ссылку для входа с любого устройства, плюс уведомление, когда для твоих стран появится детальная карта.",
      "placeholder": "ты@email.com",
      "cta": "Открыть рейтинг →",
      "sending": "Сохраняем…",
      "failed": "Не сохранилось — ссылка не ушла. Попробуй ещё раз или пропусти этот шаг: рейтинг откроется и так.",
      "privacy": "Без спама и без пароля. Отписка в один клик.",
      "skip": "Пропустить — просто показать"
    },
    "echo": {
      "horizon": {
        "now": "Переезд в этом году — сроки получения визы будут учтены.",
        "soon": "Горизонт 2–5 лет — времени на осмысленный выбор достаточно.",
        "explore": "Просто смотрю — покажем полную картину.",
        "already": "Уже переехали — поможем проверить правильность выбора."
      },
      "passport": {
        "eu": "Паспорт ЕС — большинство стран полностью доступны.",
        "anglo": "Сильный документ — небольшие сложности с банкингом в нескольких местах.",
        "ru": "Российский паспорт — отметим страны, где банки, покупка недвижимости или выдача документов сейчас фактически закрыты.",
        "by": "Белорусский паспорт — многие страны применяют российские правила; отметим ограничения для каждой страны.",
        "ua": "Украинский паспорт — большая часть ЕС/ЕЭА доступна по программе временной защиты до 2026.",
        "other": "Сосредотачиваемся на странах с подходящими визовыми путями."
      },
      "climate": {
        "alps": "Выбор горного климата — четыре сезона, прохладное сухое лето.",
        "mediterranean": "Средиземноморье — тепло, сухо, много солнца.",
        "continental": "Континентальный климат — четыре сезона, всё умеренно.",
        "tropical": "Тёплое побережье — жара и солнце как особенность, а не минус.",
        "northern": "Северный прохладный — долгие зимы, долгие летние вечера.",
        "any": "Климат не важен — будем ранжировать по другим критериям.",
        "_multi": "Два типа климата — найдём место, где пересекаются оба."
      },
      "urban_density": {
        "capital": "Столица — лучшие работы, больше англоязычных, выше стоимость.",
        "mid_city": "Средний город — оптимальное сочетание для большинства.",
        "town": "Маленький город — тише, дешевле, роль местного языка выше.",
        "coastal": "Побережье — морской воздух и небольшая влажность.",
        "_multi": "Два типа расположения — гибкий подход учтён."
      },
      "priorities": {
        "safety": "Безопасность в приоритете — фильтруем по уровню преступности и стабильности.",
        "healthcare": "Медицина в приоритете — качество государственной системы учитывается.",
        "schools": "Школы в приоритете — международные программы и обучение на английском.",
        "transport": "Транспорт в приоритете — железные дороги и городская мобильность.",
        "nature": "Природа в приоритете — горы, побережье, зелень.",
        "culture": "Культура в приоритете — еда, искусство, городская среда.",
        "ru-community": "Русскоязычная диаспора учтена — плотность сообщества влияет.",
        "sports": "Спорт в приоритете — лыжи, велосипед, хайкинг.",
        "_multi": "{{count}} приоритета зафиксированы — учтём каждый."
      },
      "income": {
        "remote": "Удалённая работа — страна заработка влияет на налоговую картину.",
        "local": "Местная работа — язык и рынок труда выдвигаются вперёд.",
        "business": "Собственный бизнес — корпоративные налоги и банкинг как ключевые фильтры.",
        "passive": "Пассивный доход — налоговые соглашения — твой главный ограничитель.",
        "_multi": "Смешанный профиль дохода — налоги и рынок труда оба взвешены."
      },
      "family": {
        "solo": "Переезжаю один — максимальная гибкость.",
        "partner": "Вместе с партнёром — оптимизируем для двоих.",
        "kids-preschool": "Маленькие дети — доступность садов и педиатрии учтена.",
        "kids-school": "Дети школьного возраста — международные школы учтены.",
        "pets": "Питомцы — правила ввоза животных будут учтены.",
        "_multi": "{{count}} человека переезжают — учтём каждого."
      },
      "languages": {
        "en": "Английский — хорошо с ним в большинстве стран из списка.",
        "it": "Итальянский — открывает южную Европу широко.",
        "es": "Испанский — Испания и латиноамериканские варианты.",
        "de": "Немецкий — регион DACH в хорошем соответствии.",
        "fr": "Французский — Франция, Бельгия, Швейцария.",
        "pt": "Португальский — Португалия и Бразилия.",
        "any": "Язык не важен — фильтр не применяется.",
        "ru-only": "Только родной язык — зоны с дружественной диаспорой и сообщества экспатов взвешены.",
        "_multi": "{{count}} языка учтены — хорошее покрытие европейских вариантов."
      },
      "dealbreakers": {
        "hot-summer": "Без жаркого лета — убираем страны с температурой выше 35°С в июле.",
        "snow": "Без снежных зим — горные варианты уменьшаются.",
        "humidity": "Низкая влажность — влажные прибрежные климаты исключены.",
        "earthquakes": "Низкая сейсмическая активность — Италия, Греция, Турция понижены.",
        "complex-visa": "Простая виза — фильтруем понятные пути.",
        "expensive-healthcare": "Доступная медицина — частные системы уменьшены.",
        "_multi": "{{count}} жёстких фильтра активны — несовпадающие страны будут исключены."
      },
      "budget": {
        "1": "До EUR 500 — хорошее соответствие в Восточной Европе и Юго-Восточной Азии.",
        "2": "EUR 500–1000 — более 15 стран остаются полностью жизнеспособными.",
        "3": "EUR 1000–2000 — Западная и Южная Европа в досягаемости.",
        "4": "EUR 2000+ — ограничений по бюджету нет."
      },
      "ties": {
        "_single": "Эта страна получит заметный буст в твоих результатах.",
        "_multi": "Все {{count}} страны с твоими связями получат дополнительный вес в рейтинге."
      }
    },
    "cost": {
      "disclaimer": "Цифры расходов — краудсорсинг livingcost.org, сверенный с официальными данными там, где они есть. Это самостоятельные оценки жителей, а не аудированные измерения — воспринимайте их как отправную точку, а не точный расчёт. Без учёта налогов, разовых расходов на переезд и выплаты основного долга по ипотеке."
    }
  },
  "countries": {
    "meta": {
      "title": "Атлас 39 стран — Lodestar",
      "description": "39 направлений для переезда с оценками по климату, стоимости, налогам, визам, медицине, языку, безопасности и семье. Фильтры по регионам и визовым путям."
    },
    "title": "Все направления",
    "subtitle": "39 стран — оценка по климату, стоимости, налогам, визам и образу жизни.",
    "filter": {
      "all": "Все",
      "europe": "Европа",
      "asia": "Азия",
      "latam": "Америки",
      "middleeast": "Ближний Восток",
      "africa": "Африка и острова"
    },
    "tier": {
      "T0": "T0 · Пионер",
      "T1": "T1 · Живые данные",
      "T2": "T2 · Скоро",
      "T3": "T3 · В планах",
      "tooltipT0": "Пионер — полные гранулярные данные по комуне + живая карта.",
      "tooltipT1": "Живые данные — метрики на уровне страны. Карта на подходе.",
      "tooltipT2": "Скоро — сбор данных в процессе.",
      "tooltipT3": "В планах — в roadmap."
    },
    "openMap": "Открыть карту →",
    "openGuide": "Открыть страницу →",
    "readGuide": "Открыть гид →",
    "checklist": "Чеклист →",
    "checklistColLabel": "Чеклист",
    "comingSoon": "Скоро",
    "startQuiz": "Найти мою страну →",
    "browseAll": "Каталог стран",
    "backToResult": "К результатам",
    "excluded": "Не подходит",
    "noData": "Скоро",
    "noResults": "В этом регионе пока нет стран.",
    "subtitlePersonal": "Отсортировано по результатам квиза — сначала лучшие совпадения.",
    "personalBanner": "Список отсортирован по твоим результатам. Сначала — страны с наибольшим совпадением.",
    "guidePromo": {
      "title": "В первый раз? Начните с руководства",
      "subtitle": "Как пользоваться картой, пинами, шортлистом и таблицей сравнения."
    },
    "scoreBand": {
      "excellent": "Отличный",
      "strong": "Сильный",
      "fair": "Средний",
      "weak": "Слабый"
    },
    "topThree": "Твоя тройка",
    "sort": {
      "label": "Сортировка",
      "match": "По совпадению",
      "tier": "По tier",
      "name": "По названию",
      "cost": "По стоимости",
      "tax": "По налогам"
    },
    "view": {
      "label": "Вид",
      "grid": "Сетка",
      "list": "Список"
    },
    "metrics": {
      "costShort": "{{amount}}/мес",
      "taxShort": "{{rate}}% налог",
      "costLabel": "Стоимость",
      "taxLabel": "Налог",
      "costHelper": "Аренда, продукты, коммуналка, транспорт, здоровье и повседневные траты. Детский сад и школа считаются отдельно.",
      "taxHelper": "Максимальная ставка подоходного налога",
      "dataNote": "Цифры ниже — типичная стоимость для маленькой семьи в месяц (аренда + коммуналка + продукты, в EUR) и максимальная ставка подоходного налога.",
      "costIn": "{{household}} · {{city}}",
      "costHousehold": {
        "single": "один человек",
        "couple": "пара",
        "family_1": "двое взрослых, один ребёнок",
        "family_2": "двое взрослых, двое детей",
        "family_3": "двое взрослых, трое детей"
      }
    },
    "visa": {
      "label": "Виза",
      "any": "Любой путь",
      "nomad": "Удалёнка / номад",
      "freelance": "Фриланс / ИП",
      "investment": "Инвестиции / golden"
    },
    "shipping": {
      "title": "Карты на подходе",
      "subtitle": "Живые данные по странам, полные карты — в ближайшие кварталы.",
      "quarter": "Q{{q}} {{year}}"
    },
    "excludedSection": {
      "title": "Не подходит ({{count}})",
      "subtitle": "Страны, исключённые по жёстким ограничениям — паспорт, банкинг, климат.",
      "expand": "Показать",
      "collapse": "Скрыть"
    },
    "regionFilterLabel": "Фильтр по региону",
    "regionName": {
      "africa": "Африка",
      "americas": "Америки",
      "asia": "Азия",
      "caribbean": "Карибы",
      "caucasus": "Кавказ",
      "europe": "Европа",
      "indianOcean": "Индийский океан",
      "latam": "Латинская Америка",
      "middleEast": "Ближний Восток",
      "southAmerica": "Южная Америка",
      "southeastAsia": "Юго-Восточная Азия"
    }
  },
  "header": {
    "signIn": "Войти",
    "signOut": "Выйти",
    "countryGuides": "Гиды стран",
    "howTo": "Инструкция",
    "guides": "Гиды",
    "guidesTitle": "Гиды стран",
    "guidesFull": "Гид",
    "guidesChecklist": "Чеклист переезда",
    "guidesAll": "Все 39 стран →",
    "guidesTopics": "По темам →",
    "guidesTooltip": "Энциклопедические гиды по странам (Италия, Португалия, Испания, ОАЭ)",
    "howToTooltip": "Инструкция по сайту — Field Guide",
    "nav": "Главное меню"
  },
  "language": {
    "switcherAria": "Текущий язык: {{current}}. Сменить язык",
    "listAria": "Выбор языка"
  },
  "share": {
    "button": "Поделиться",
    "copied": "Скопировано",
    "title": "Lodestar",
    "tooltip": "Скопировать ссылку на текущий вид",
    "aria": "Поделиться текущим видом карты"
  },
  "a11y": {
    "skipToContent": "Перейти к карте",
    "mapRegion": "Интерактивная карта Италии. Альтернатива для screen-reader: используйте панели Фильтры, Слой, POI."
  },
  "offline": {
    "banner": "Нет соединения. Загруженные данные останутся доступны, новые слои могут не подгрузиться."
  },
  "loading": {
    "default": "Загрузка…",
    "data": "Загрузка данных…",
    "list": "Загрузка списка…",
    "profile": "Загрузка профиля…"
  },
  "errors": {
    "root": {
      "title": "Что-то пошло не так",
      "description": "Произошла ошибка. Мы получили уведомление и разберёмся. Попробуй перезагрузить страницу.",
      "reload": "Перезагрузить"
    },
    "feature": {
      "fallback": "Не удалось загрузить раздел"
    }
  },
  "filters": {
    "title": "Фильтры",
    "open": "Открыть фильтры",
    "close": "Свернуть фильтры",
    "totalCount": "Всего: {{count}} · {{unitPlural}}",
    "matched": "Подходит:",
    "reset": "Сбросить фильтры",
    "noFilterValue": "— нет —",
    "altitude": "Высота",
    "tJulMax": "T° июля не более",
    "tJanMin": "T° января не менее",
    "humMax": "Влажность не более",
    "snowMin": "Снежных дней не менее",
    "sunnyMin": "Солнечных дней не менее",
    "zonesTitle": "Зона рельефа",
    "empty": {
      "title": "Ничего не подходит",
      "constraintDesc": "Самый жёсткий фильтр: <strong>{{label}}</strong> (отсекает {{pct}}%).",
      "relax": "Ослабить «{{label}}»",
      "fallback": "Попробуй сбросить все фильтры и сузить запрос постепенно.",
      "resetAll": "Сбросить всё"
    },
    "matchedAria": "Найдено: {{count}}",
    "matchedZeroAria": "Ничего не найдено по текущим фильтрам"
  },
  "constraints": {
    "alt": "Высота",
    "tJulMax": "T° июля",
    "tJanMin": "T° января",
    "humMax": "Влажность",
    "snowMin": "Снежных дней",
    "sunnyMin": "Солнечных дней",
    "zones": "Зона рельефа",
    "popMax": "Население",
    "hospMax": "До больницы"
  },
  "zones": {
    "pianura": "Равнина",
    "collina_interna": "Холмы (внутр)",
    "collina_litoranea": "Холмы (побер)",
    "montagna_interna": "Горы (внутр)",
    "montagna_litoranea": "Горы (побер)"
  },
  "presets": {
    "my_profile": "Демо-профиль",
    "alpine": "Высокогорье",
    "subalpine": "Субальпийский",
    "lakeside": "Озёрный",
    "dolomites": "Доломиты",
    "noheat": "Без жары"
  },
  "layer": {
    "title": "Слой карты",
    "openSheet": "Открыть выбор слоя",
    "mode": {
      "label": "Режим отображения",
      "choropleth": "По зонам",
      "heatmap": "Тепловая",
      "none": "Без слоёв",
      "noneHint": "Скрыть цветную заливку — оставить только подложку. На zoom 15+ срабатывает автоматически."
    },
    "addon": {
      "terrain": "Рельеф"
    },
    "group": {
      "climate": "Климат",
      "economy": "Экономика",
      "tax": "Налоги",
      "infra": "Инфраструктура",
      "demo": "Демография"
    },
    "noData": "нет данных",
    "filterActive": "Фильтр активен — маска изменена",
    "filterActiveHidden": "Фильтры активны, но слой данных скрыт — результат не виден на карте.",
    "showLayer": "Включить слой",
    "label": {
      "altitude": "Высота",
      "t_mean": "Средняя T° (год)",
      "t_jul": "T° июля",
      "t_jan": "T° января",
      "humidity": "Влажность",
      "precip": "Осадки (год)",
      "snow": "Снежных дней",
      "sunny": "Солнечных дней",
      "rent": "Аренда €/м²/год",
      "sale": "Продажа €/м²",
      "income": "Средний доход",
      "internet": "Интернет",
      "hospital": "До больницы",
      "train": "До ЖД-станции",
      "density": "Плотность населения",
      "foreign_total": "Иностранцы (% жителей)",
      "foreign_ru": "Русскоязычные (Россия %)",
      "foreign_ua": "Украинцы (%)",
      "foreign_by": "Белорусы (%)",
      "irpef": "Доп. IRPEF (% от дохода)"
    }
  },
  "poi": {
    "title": "Точки на карте",
    "open": "Открыть POI",
    "openAria": "Открыть точки на карте",
    "close": "Свернуть",
    "closeAria": "Свернуть панель POI",
    "enableAll": "Включить все слои",
    "groupEnableAria": "Включить все в группе {{group}}",
    "autoHint": {
      "message": "Включил базовую инфраструктуру: больницы, аптеки, школы, ЖД.",
      "optInPrompt": "Показать на карте базовую инфраструктуру (больницы, аптеки, школы, ЖД)?",
      "personaPrompt": "Показать POI под твой профиль ({{label}})?",
      "enable": "Показать",
      "configure": "Настроить",
      "dismiss": "Закрыть"
    },
    "group": {
      "transport": "Транспорт",
      "essentials": "Бытовое",
      "sports": "Спорт и отдых",
      "kids": "Детям",
      "adults": "Взрослым"
    },
    "category": {
      "hospitals": "Больницы",
      "pharmacies": "Аптеки",
      "schools": "Школы",
      "kindergartens": "Детсады",
      "language_schools": "Языковые школы",
      "stations": "ЖД-станции",
      "airports": "Аэропорты",
      "supermarkets": "Магазины",
      "ski_areas": "Горнолыжные курорты",
      "ski_resorts": "Подъёмники",
      "alpine_huts": "Рифуджи",
      "yoga": "Йога-студии",
      "gym": "Тренажёрные залы",
      "courts": "Спортплощадки (теннис/паддл/мульти)",
      "pools": "Бассейны",
      "coworking": "Коворкинги",
      "weather_stations": "Метеостанции"
    }
  },
  "places": {
    "title": "Места",
    "open": "Открыть выбор мест",
    "close": "Свернуть",
    "closeAria": "Свернуть панель мест",
    "countSelected": "{{count}} выбрано",
    "searchPlaceholder": "Регионы, {{unitPlural}}, города (мин. 2 буквы)…",
    "removeFromFavorites": "Удалить из выбранного",
    "moreItems": "+{{count}} ещё",
    "minQueryTitle": "Поиск: {{unit}}",
    "minQueryDesc": "Введите хотя бы 2 буквы названия (например «Trento» или «Bolzano»). Совпадения можно добавить в избранное и показать сразу на карте.",
    "noResultsTitle": "Не нашлось «{{q}}»",
    "noResultsDesc": "Проверь раскладку или попробуй короче (2–3 буквы).",
    "limitNote": "Показано первые {{count}}. Уточните запрос.",
    "showOnMap": "Показать на карте",
    "showAllSelected": "Показать всё на карте",
    "clear": "Очистить",
    "clearConfirm": "Точно? Удалить",
    "clearConfirmTitle": "Нажмите ещё раз, чтобы удалить все"
  },
  "details": {
    "loading": "Загрузка данных…",
    "close": "Закрыть детали",
    "closeTooltip": "Закрыть (Esc)",
    "italyGuide": {
      "heading": "Об Италии",
      "visa": "Визовые треки",
      "taxes": "Налоговые режимы",
      "cost": "Стоимость жизни",
      "property": "Покупка недвижимости",
      "hub": "Полный гид по Италии →"
    },
    "section": {
      "profileFit": "Анализ соответствия",
      "yearRound": "По месяцам",
      "climate": "Климат",
      "infra": "Инфраструктура",
      "internet": "Интернет",
      "demo": "Демография",
      "tax": "Налоги",
      "foreign": "Иностранцы",
      "econ": "Экономика",
      "propertyTax": "Налог на недвижимость (IT)"
    },
    "monthly": {
      "temp": "Температура по месяцам",
      "precip": "Осадки по месяцам",
      "humidity": "Влажность по месяцам",
      "sunny": "Солнечных дней по месяцам",
      "disclaimer": "Сезонная оценка из годовых показателей. Точные месячные значения — со следующей итерации pipeline.",
      "realData": "Реальные климатические нормали NASA POWER 1991–2020, с downscale по высоте.",
      "snow": "Снежных дней по месяцам"
    },
    "kpi": {
      "altitude": "Высота",
      "tMean": "T° ср",
      "hospital": "Больница",
      "internet": "Интернет"
    },
    "photo": {
      "source": "Wikipedia · italiano",
      "openOnWikipedia": "Открыть в Википедии"
    },
    "row": {
      "tMean": "Средняя T° (год)",
      "tJul": "T° июля",
      "tJan": "T° января",
      "hotDays": "Жарких дней",
      "humidity": "Влажность",
      "precip": "Осадки",
      "snowDays": "Снежных дней",
      "sunnyDays": "Солнечных дней",
      "sunHours": "Сумма солн. часов",
      "toHospital": "До больницы",
      "toPharmacy": "До аптеки",
      "toSchool": "До школы",
      "toTrain": "До ЖД-станции",
      "toAirport": "До аэропорта",
      "toSupermarket": "До магазина",
      "toHut": "До рифуджо",
      "toSki": "До подъёмника",
      "skiN20": "Подъёмников в 20км",
      "dl": "Скорость download",
      "ul": "Скорость upload",
      "ping": "Пинг",
      "population": "Население",
      "density": "Плотность",
      "zone": "Зона рельефа",
      "irpefMax": "Доп. IRPEF (макс. ставка)",
      "irpefExempt": "Освобождение до дохода",
      "foreignTotal": "Всего иностранцев",
      "foreignRu": "🇷🇺 Россия",
      "foreignUa": "🇺🇦 Украина",
      "foreignBy": "🇧🇾 Беларусь",
      "rent": "Аренда",
      "sale": "Продажа",
      "income": "Средний доход"
    },
    "collapse": "Свернуть панель",
    "expand": "Развернуть панель",
    "propertyTax": {
      "perComuneNote": "Коэффициент IMU по отдельным коммунам пока не включён в данные — приведённые цифры отражают национальные диапазоны."
    }
  },
  "search": {
    "inputAria": "Поиск: регион, {{unit}} или город",
    "clearAria": "Очистить поиск",
    "favoritesOpen": "Открыть избранное",
    "favoritesAria": "Избранное: {{count}}",
    "starAdd": "Добавить в избранное",
    "starRemove": "Удалить из избранного",
    "flyTo": "Перейти к {{name}}",
    "removeNamed": "Удалить {{name}}",
    "geocodeFallback": "Поиск по названию города (OSM)",
    "geocodeLoading": "Ищем в OpenStreetMap…",
    "geocodeNoMatch": "Совпадений не найдено ({{country}}). Попробуйте другое написание.",
    "geocodeFound": "Открыть",
    "cyrillicHint": "Названия итальянских мест хранятся латиницей. Попробуйте «Trento» вместо «Тренто».",
    "section": {
      "regions": "Регионы",
      "comuni": "{{unitPlural}}",
      "places": "Другие места (OSM)"
    },
    "comuniSuffix": "· {{unitPlural}}"
  },
  "login": {
    "title": "Вход в Lodestar",
    "google": "Войти через Google",
    "or": "или",
    "emailPlaceholder": "email@example.com",
    "submit": "Получить ссылку для входа",
    "submitting": "Отправляем…",
    "sent": "Ссылка отправлена",
    "sentHint": "Проверьте почту (включая спам). Ссылка действует 15 минут.",
    "back": "← На главную",
    "errorSend": "Не удалось отправить ссылку",
    "errorGeneric": "Ошибка отправки",
    "errorGoogle": "Ошибка Google OAuth"
  },
  "shortlist": {
    "title": "Мои списки",
    "open": "Открыть списки",
    "empty": "У вас пока нет списков",
    "emptyHint": "Сохраняйте {{unitPlural}}, чтобы потом их сравнивать",
    "create": "Создать список",
    "createPlaceholder": "Название списка",
    "createSubmit": "Создать",
    "rename": "Переименовать",
    "remove": "Удалить список",
    "removeConfirm": "Удалить этот список?",
    "guestHint": "Списки сохранены в этом браузере. Войдите, чтобы получить доступ с любого устройства.",
    "syncingDirty": "Сохраняем…",
    "syncedLabel": "Сохранено",
    "save": "Сохранить",
    "saved": "Сохранено",
    "unsave": "Убрать из сохранённых",
    "addToList": "Добавить в список",
    "removeFromList": "Убрать из списка",
    "notePlaceholder": "Заметка (видна только вам)",
    "noteSave": "Сохранить",
    "viewOnMap": "Показать всё на карте",
    "compare": "Сравнить",
    "exportCsv": "Экспорт CSV",
    "activeBadge": "Активный",
    "selectActive": "Сделать активным",
    "deletedConfirm": "Список удалён",
    "loginToSync": "Войти для синка",
    "close": "Закрыть",
    "planVisit": "Спланировать визит",
    "planVisitTrim": "В маршрут попадут первые 7 из {{count}} остановок.",
    "checklist": "Чек-лист переезда",
    "checklistHint": "Следующие шаги после решения: виза, codice fiscale, residency",
    "items": "{{count}} · {{unitPlural}}"
  },
  "pins": {
    "nearbyTitle_one": "{{count}} ваш пин рядом",
    "nearbyTitle_few": "{{count}} ваших пина рядом",
    "nearbyTitle_many": "{{count}} ваших пинов рядом",
    "nearbyTitle_other": "{{count}} ваших пинов рядом",
    "nearbyMore": "ещё {{count}}",
    "nearbyDistance": "{{km}} км",
    "nearbyInComune": "внутри границ",
    "nearbyOpen": "Показать на карте",
    "demoBadge": "демо",
    "demoHint": "Демонстрационное объявление. Войдите, чтобы сохранять свои пины.",
    "demoWhat": "Что это?",
    "demoWhatBody": "Демо-пин — пример объявления. Так будут выглядеть ваши сохранённые места.",
    "demoWhy": "Почему здесь?",
    "demoWhyBody": "Карта показывает демо-данные анонимным пользователям, чтобы она не была пустой.",
    "demoHow": "Как пользоваться?",
    "demoHowBody": "Войдите в аккаунт и сохраняйте понравившиеся места — они появятся здесь с оценками по климату и инфраструктуре.",
    "demoHide": "✕ Скрыть демо-пины",
    "demoSignIn": "Войти в аккаунт →",
    "deleteConfirm": "Удалить этот пин?",
    "delete": "Удалить",
    "add": "Запинить это место",
    "addTitle": "Запинить это место",
    "bulk": {
      "addresses": "Адреса",
      "cappedAt": "(не более первых {{max}} за один раз)",
      "csv": "CSV",
      "importing": "Импортируем…",
      "openLabel": "Импорт",
      "openTitle": "Импортировать шорт-лист мест",
      "parsed": "Распознано адресов: {{count}}",
      "parsedUrls": "Распознано ссылок: {{count}}",
      "progress": "{{done}} из {{total}}",
      "start": "Импортировать",
      "statusExtracting": "извлекаем",
      "statusGeocoding": "геокодируем",
      "statusSaving": "сохраняем",
      "subtitle": "Вставьте адреса (по одному в строке) или CSV. Каждый адрес мы геокодируем через Nominatim — около 1 секунды на адрес.",
      "subtitleUrls": "Вставьте ссылки на объявления (по одной в строке). Мы извлекаем координаты со страницы — работает с Immobiliare.it, Idealista.it, Casa.it и другими.",
      "summary": "Импортировано: {{ok}}; не удалось: {{fail}}.",
      "title": "Импортировать шорт-лист мест",
      "urls": "Ссылки"
    },
    "errorGeneric": "Не удалось сохранить пин",
    "fieldNotes": "Заметки",
    "fieldTitle": "Название",
    "fieldUrl": "Ссылка на объявление (по желанию)",
    "nearbyTitle": "Пины поблизости",
    "openComune": "Открыть метрики",
    "openComuneNamed": "Метрики: {{name}}",
    "save": "Сохранить пин",
    "saving": "Сохраняем…",
    "shortAdd": "Пин",
    "titleRequired": "Укажите название",
    "validation": {
      "compare": "Сравнить →",
      "indicator": "У вас {{count}} мест на карте"
    }
  },
  "account": {
    "title": "Аккаунт",
    "email": "Email",
    "name": "Имя",
    "namePlaceholder": "Ваше имя",
    "save": "Сохранить",
    "saved": "Сохранено",
    "saving": "Сохраняем…",
    "preferences": "Настройки",
    "language": "Язык",
    "theme": "Тема",
    "themeLight": "Светлая",
    "themeDark": "Тёмная",
    "themeAuto": "Системная",
    "defaultLayer": "Слой по умолчанию",
    "stats": "Ваши данные",
    "statsLists_one": "{{count}} список",
    "statsLists_few": "{{count}} списка",
    "statsLists_many": "{{count}} списков",
    "statsLists_other": "{{count}} списков",
    "statsProfiles_one": "{{count}} профиль",
    "statsProfiles_few": "{{count}} профиля",
    "statsProfiles_many": "{{count}} профилей",
    "statsProfiles_other": "{{count}} профилей",
    "statsPins_one": "{{count}} пин",
    "statsPins_few": "{{count}} пина",
    "statsPins_many": "{{count}} пинов",
    "statsPins_other": "{{count}} пинов",
    "danger": "Опасная зона",
    "deleteAccount": "Удалить аккаунт",
    "deleteHint": "Аккаунт и все данные (списки, профили, пины) будут безвозвратно удалены.",
    "deleteConfirmTitle": "Удалить аккаунт?",
    "deleteConfirmBody": "Это необратимо. Напишите «УДАЛИТЬ», чтобы подтвердить.",
    "deleteConfirmInput": "УДАЛИТЬ",
    "deleteConfirmCta": "Удалить навсегда",
    "cancel": "Отмена",
    "back": "← На карту",
    "signOut": "Выйти",
    "notSignedIn": "Вы не вошли в аккаунт",
    "signIn": "Войти",
    "matchTitle": "Ваш матч",
    "matchEmpty": "Вы ещё не проходили квиз.",
    "matchEmptyCta": "Пройти квиз за 2 минуты",
    "matchLoading": "Загружаем сохранённый матч…",
    "matchOpenFull": "Открыть полный результат",
    "matchRetake": "Пройти заново",
    "matchTakenOn": "Пройден {{date}}",
    "matchRank": "#{{rank}}",
    "checklistsTitle": "Сохранённые чеклисты",
    "checklistsEmpty": "Вы ещё не сохраняли страны. Закрепите место с карты или сохраните чеклист на странице страны.",
    "checklistsBrowse": "Все 39 стран",
    "checklistOpen": "Открыть чеклист",
    "checklistsInfoTitle": "Полезное по вашим странам",
    "checklistsInfoTax": "Налоги",
    "checklistsInfoCar": "Авто",
    "checklistsInfoVisa": "Виза",
    "checklistsInfoNoData": "Данных пока нет",
    "exportCta": "Экспортировать мои данные",
    "exportHint": "Скачайте копию в формате JSON со своими профилями, шорт-листами, пинами и настройками.",
    "exporting": "Готовим…",
    "exportTitle": "Ваши данные",
    "statsLists": "Списки",
    "statsPins": "Пины",
    "statsProfiles": "Профили"
  },
  "gdpr": {
    "bannerTitle": "Cookies и приватность",
    "bannerBody": "Мы используем только необходимые cookies (сессия входа) и анонимную аналитику. Без сторонних трекеров и рекламы.",
    "accept": "Понятно",
    "details": "Подробнее",
    "privacy": "Политика конфиденциальности",
    "terms": "Условия использования"
  },
  "propertyTax": {
    "summaryTitle": "Жильё в этой стране",
    "label": "Налог на недвижимость",
    "loading": "Загрузка…",
    "noData": "Данных по налогу на недвижимость для этой страны пока нет.",
    "placeholder": "Точные ставки для этой страны ещё уточняются — спросите AI-ассистента или консультанта.",
    "tier": {
      "low": "Низкий",
      "medium": "Средний",
      "high": "Высокий"
    },
    "row": {
      "annual": "Годовой налог",
      "purchase": "Налог при покупке (разовый)",
      "capitalGains": "Налог с продажи",
      "wealth": "Налог на недвижимость как актив",
      "regime": "Режим для иностранцев"
    },
    "value": {
      "noAnnualTax": "Годового налога нет",
      "primary": "основное",
      "primaryExempt": "основное жильё освобождено",
      "secondHome": "второе жильё",
      "primaryAlwaysExempt": "основное жильё всегда освобождено",
      "primaryExemptAfter": "основное жильё освобождено после {{years}} лет",
      "secondHomeExemptAfter": "второе жильё освобождено после {{years}} лет",
      "over65PrimaryExempt": "основное жильё освобождено для лиц 65+",
      "lifetimeExemption": "пожизненное освобождение €{{amount}}",
      "threshold": "порог €{{amount}}тыс."
    }
  },
  "carOwnership": {
    "summaryTitle": "Расходы на автомобиль",
    "chipMonthly": "~€{{amount}}/мес",
    "comparePage": {
      "label": "Авторасходы (на уровне страны)",
      "note": "Одинаковы для всех comuni — оценка по стране в целом."
    },
    "quizCard": {
      "tier": {
        "very_low": "Авто — недорого",
        "low": "Авто — недорого",
        "medium": "Авто — средне",
        "high": "Авто — дорого",
        "very_high": "Авто — очень дорого"
      }
    }
  },
  "compare": {
    "title": "Сравнение",
    "needMore": "Выберите минимум 2 comuni для сравнения. Откройте «Списки» и нажмите «Сравнить».",
    "notFound": "Comuni не найдены по указанным ISTAT.",
    "metric": "Показатель",
    "hint": "Зелёным — лучшее значение в строке, красным — худшее (для расстояний и жарких дней меньше = лучше).",
    "copyLink": "↗ Поделиться",
    "linkCopied": "✓ Скопировано!",
    "exportCsv": "⬇ CSV",
    "print": "⎙ Печать / PDF",
    "queued_one": "Выбран {{count}}",
    "queued_few": "Выбрано {{count}}",
    "queued_many": "Выбрано {{count}}",
    "queued_other": "Выбрано {{count}}",
    "clearAll": "Очистить сравнение",
    "barAriaLabel": "Очередь сравнения",
    "go": "Сравнить →",
    "units": {
      "m": "м",
      "km": "км",
      "celsius": "°C",
      "percent": "%",
      "mm": "мм",
      "mbps": "Мбит/с",
      "ms": "мс",
      "personsPerKm2": "чел/км²"
    },
    "add": "Сравнить",
    "emptyEyebrow": "Сравнение бок о бок",
    "emptyLead": "Эта страница выстраивает до 5 итальянских коммун бок о бок по климату, инфраструктуре, интернету, налогам и демографии — чтобы вы видели все компромиссы с первого взгляда, а не перещёлкивали вкладки.",
    "emptyMapCta": "Открыть карту Италии",
    "emptyMetric": "Показатель",
    "emptyQuizCta": "Или пройдите тест по странам",
    "emptyRecoCta": "Показать лучшие регионы для меня",
    "emptySampleLabel": "Как это выглядит в заполненном виде",
    "emptySampleNote": "Выделенные ячейки — лучшее в строке",
    "emptyStepsAria": "Как заполнить сравнение",
    "emptyTitle": "В вашем сравнении пока нет коммун.",
    "full": "Список сравнения заполнен (максимум 5)",
    "inList": "В сравнении",
    "propertyTax": {
      "label": "Налог на недвижимость (на уровне страны)",
      "note": "Одинаков на национальном уровне для всех перечисленных коммун — коэффициенты IMU по отдельным коммунам пока не включены в данные."
    },
    "queued": "Выбрано: {{count}}",
    "remove": "Убрать из сравнения",
    "step1": {
      "body": "Просматривайте Италию по зонам или сразу переходите к регионам, которые тест оценил высоко.",
      "title": "Откройте карту или рекомендатель"
    },
    "step2": {
      "body": "В панели деталей любой коммуны нажмите чип «⊞ Сравнить». Повторите 2–5 раз.",
      "title": "Нажмите на коммуну → ⊞ Сравнить"
    },
    "step3": {
      "body": "Нажмите кнопку «Сравнить» в панели шорт-листа, чтобы вернуться на эту страницу с уже заполненными данными.",
      "title": "Вернитесь сюда"
    }
  },
  "privacy": {
    "title": "Политика конфиденциальности",
    "back": "← Назад",
    "updated": "Обновлено: {{date}}",
    "intro": "Lodestar — открытый проект, помогающий сравнивать города и страны для переезда. Мы собираем минимум данных, необходимых для работы и улучшения сервиса.",
    "store": {
      "title": "Что мы храним",
      "account": "<b>Аккаунт</b> — email (только если вы вошли), отображаемое имя (необязательно), сессии авторизации.",
      "personal": "<b>Ваши персональные данные</b> — списки сохранённых comuni, заметки, профили скоринга, пины. Хранятся в нашей базе Cloudflare D1 и привязаны к аккаунту.",
      "analytics": "<b>Анонимная аналитика</b> — просмотры страниц, клики, метрики производительности (LCP/INP/CLS). Без рекламных трекеров и сторонней аналитики. Мы можем хранить анонимный идентификатор сессии и страну (по IP) для агрегированной статистики.",
      "logs": "<b>Логи</b> — отчёты об ошибках в Sentry (если включён). Стек-трейсы и метаданные запроса, без PII."
    },
    "noDo": {
      "title": "Чего мы не делаем",
      "noSell": "Не продаём и не передаём ваши данные рекламодателям.",
      "noTrackers": "Не используем сторонние cookies, fingerprinting и поведенческие рекламные сети.",
      "noPayment": "Не храним платёжную информацию (сервис бесплатный)."
    },
    "partners": {
      "title": "Передача проверенным партнёрам-консультантам",
      "body": "Когда вы отправляете запрос на консультацию и ставите галочку согласия, мы можем передать ваши контактные данные (имя, email, опционально телефон) и краткое описание запроса (страна, категория услуги, сроки) одному или нескольким проверенным партнёрам-консультантам. После принятия заявки партнёры становятся независимыми контролёрами данных и связаны с нами Соглашением об обработке данных. Согласие можно отозвать в любой момент, написав на ",
      "after": ". Правовая основа: ваше явное согласие (GDPR ст. 6(1)(a)) и исполнение запрошенной услуги-знакомства (ст. 6(1)(b))."
    },
    "rights": {
      "title": "Ваши права (GDPR)",
      "access": "<b>Доступ</b> — скачать все ваши данные через API или по запросу на email.",
      "erasureBefore": "<b>Удаление</b> — кнопка «Удалить аккаунт» на ",
      "erasureLink": "странице аккаунта",
      "erasureAfter": ". Это безвозвратно.",
      "portability": "<b>Переносимость</b> — экспорт списков в CSV из drawer «Мои списки»."
    },
    "contact": {
      "title": "Контакт",
      "before": "Вопросы и запросы: ",
      "after": "."
    }
  },
  "terms": {
    "title": "Условия использования",
    "back": "← Назад",
    "updated": "Обновлено: {{date}}",
    "s1": {
      "title": "1. О сервисе",
      "body": "Lodestar — бесплатный open-source инструмент, агрегирующий публичные данные (ISTAT, Open-Meteo, CHELSA, OpenStreetMap, MEF) для сравнения городов. Информация носит справочный характер и не является юридической, налоговой, финансовой или иммиграционной консультацией."
    },
    "s2": {
      "title": "2. Без гарантий",
      "body": "Данные предоставляются «как есть», без гарантий точности и полноты. Мы стараемся держать их актуальными, но важные решения проверяйте по первоисточникам."
    },
    "s3": {
      "title": "3. Допустимое использование",
      "personal": "Используйте сервис для личного, некоммерческого исследования места жительства.",
      "noScrape": "Не скрейпите API с высокой частотой (rate limits применяются).",
      "noAbuse": "Не используйте публикацию профилей для спама и преследования."
    },
    "s4": {
      "title": "4. Ваш контент",
      "body": "Профили, помеченные как «публичные», видны другим. Всё остальное (списки, пины, заметки) приватно. Право на контент остаётся за вами."
    },
    "s5": {
      "title": "5. Изменения",
      "body": "Условия могут обновляться. Существенные изменения будут отмечены в приложении. Продолжение использования после изменения = согласие."
    },
    "s6": {
      "title": "6. Контакт",
      "before": "Вопросы по данным — в ",
      "link": "политике конфиденциальности",
      "after": "."
    },
    "s7": {
      "title": "7. Покупки и оплата",
      "body": "Часть сервиса платная. «Персональный отчёт о релокации» — это разовая цифровая покупка (€29), которая формируется автоматически из ваших ответов в квизе и сразу выдаётся в виде личной ссылки, остающейся у вас. Это информационный ориентир, а не юридическая, налоговая или иммиграционная консультация. Платежи обрабатывает Lemon Squeezy — наш Merchant of Record, который также отвечает за счета и применимые налоги. Возвраты регулируются нашей ",
      "link": "Политикой возврата",
      "after": "."
    }
  },
  "property": {
    "sectionTitle": "В продаже / в аренду",
    "sale": "В продаже",
    "rent": "В аренду",
    "count": "объявлений",
    "sourceNote": "Объявления агрегированы из открытых данных — проверь на источнике перед связью."
  },
  "reco": {
    "needQuiz": "Пройди квиз — нам нужен твой профиль, чтобы ранжировать регионы.",
    "startQuiz": "Пройти квиз →",
    "backToResult": "Назад к результатам квиза",
    "backHome": "Вернуться в Lodestar",
    "title": "Топ регионов Италии для твоего профиля",
    "subtitle": "Ранжируем по ответам — климат, стоимость, инфраструктура, интернет. Клик по региону — открыть карту с приближением.",
    "noData": "Данных по регионам пока нет.",
    "matchLabel": "Совпадение",
    "openMap": "Открыть на карте →",
    "italyContext": "Показываем регионы Италии, потому что Италия — топ-1 в твоих результатах.",
    "showComuni": "Топ-10 коммун →",
    "hideComuni": "Скрыть топ-10",
    "personaBadge": "Определённый профиль: {{label}}",
    "minimap": {
      "title": "Где этот регион на карте Италии",
      "caption_one": "{{count}} коммуна · регион выделен",
      "caption_few": "{{count}} коммуны · регион выделен",
      "caption_many": "{{count}} коммун · регион выделен",
      "caption_other": "{{count}} коммун · регион выделен",
      "caption": "{{count}} коммун · регион выделен"
    },
    "dim": {
      "climate": "Климат",
      "cost": "Цена",
      "infra": "Инфра",
      "internet": "Интернет"
    },
    "reason": {
      "alpineClimate": "Альпийский характер: средняя высота {{alt}} м",
      "mediterraneanWarmth": "Средиземноморская теплота: медианный июль {{temp}} °C",
      "continentalSeasons": "Континентальные сезоны: январь {{tJan}} °C, июль {{tJul}} °C",
      "climateFit": "Климат соответствует вашему выбору",
      "climateAvg": "Климат подходит: средняя {{temp}} °C, {{sunny}} солнечных дней в году",
      "climateAvgTemp": "Климат подходит: средняя {{temp}} °C, июль {{tJul}} °C",
      "affordable": "Доступно для вашего бюджета: ~{{rent}} €/м²/год",
      "strongInternet": "Уверенный интернет: {{mbps}} Мбит/с (медиана)",
      "infrastructureAccess": "Инфраструктура рядом: больница ~{{hospital}} км, поезд ~{{train}} км",
      "transitAccess": "Транспорт рядом: поезд ~{{train}} км, аэропорт ~{{airport}} км",
      "familyReady": "Подходит для семьи: школа ~{{school}} км, больница ~{{hospital}} км",
      "outdoorAccess": "Доступ к природе: подъёмник ~{{ski}} км"
    },
    "landing": {
      "title": "Выбери правильный регион Италии — а не просто правильную страну.",
      "subtitle": "В Италии 20 регионов, 7 896 коммун и три климата. «Италия 87 %» ничего не говорит о том, где жить. Эта страница сужает поиск до топ-5 регионов — альпы или Средиземноморье, город или село, дорого или дёшево — на основе твоего профиля переезда.",
      "howLabel": "Как это работает",
      "step1Title": "Пройди двухминутный квиз",
      "step1Body": "10 вопросов про климат, бюджет, семью и приоритеты. Тот же квиз, что ранжирует 31 страну — мы используем те же ответы и для регионов. Отдельного регионального квиза нет.",
      "step2Title": "Мы оцениваем 20 итальянских регионов",
      "step2Body": "Каждый регион получает совпадение % по четырём осям — климат, стоимость, инфраструктура, интернет — с 2–3 причинами простым языком. Пример ниже.",
      "step3Title": "Углубляйся в топ-10 коммун",
      "step3Body": "Разверни любой регион, чтобы увидеть 10 наиболее совпавших коммун внутри — с высотой, оценкой и короткой пометкой, почему подходит. Клик — карта на уровне коммуны.",
      "sampleLabel": "Пример результата",
      "sampleRegion": "Трентино — Альто-Адидже",
      "sampleMeta": "282 коммуны · 1,07 млн жителей",
      "sampleReason1": "Альпийский климат соответствует приоритету (средняя высота 600 м+, снежных дней 25+ в год).",
      "sampleReason2": "Медианная аренда €11,4/м² — на 30 % ниже Милана, на 15 % ниже Флоренции.",
      "sampleReason3": "Самая высокая плотность больниц и подъёмников на севере Италии.",
      "sampleNote": "Образцовые данные. Реальные результаты зависят от твоих ответов в квизе.",
      "personasLabel": "Разные профили — разные ранжирования",
      "personasBody": "Из квиза мы определяем пять архетипов — каждый по-своему взвешивает климат, стоимость и инфраструктуру. Семье с детьми и digital-номаду не следует советовать жить в одном месте.",
      "ctaLabel": "Начать",
      "cta": "Пройти двухминутный квиз",
      "ctaSkip": "Или открыть всю карту Италии (8 000 коммун, без фильтра)",
      "ctaHint": "Без регистрации. Анонимно. Квиз ~2 минуты."
    }
  },
  "persona": {
    "family": "Семья с детьми",
    "nomad": "Удалёнщик / digital nomad",
    "sport": "Активный отдых / горы",
    "quiet": "Спокойная сельская жизнь",
    "urban": "Город / культура"
  },
  "ai": {
    "openBubble": "Спросить помощника по релокации",
    "close": "Закрыть",
    "title": "Lodestar помощник",
    "placeholder": "Задайте вопрос…",
    "submit": "Спросить",
    "thinking": "Думаю…",
    "emptyAnswer": "Пустой ответ — переформулируйте.",
    "networkError": "Ошибка сети.",
    "stubBadge": "Заглушка — Anthropic API key не установлен на этом деплое.",
    "intro": {
      "details": "Спросите что угодно про это место — климат, инфраструктура, налоги, демография. Ответы из загруженных данных, без выдумок.",
      "quiz": "Непонятен вопрос квиза? Спросите, что он значит и как влияет на рейтинг.",
      "quiz_result": "Спросите, почему страна на этом месте, или сравните две.",
      "recommendations": "Спросите, почему регион здесь, или сравните два региона.",
      "map": "Спросите про активный слой, фильтры или видимые {{unitPlural}}.",
      "next_steps": "Спросите про пункт чек-листа: что значит, с чего начать, к кому обратиться."
    },
    "askAnother": "← Спросить ещё",
    "contextLabel": "Контекст",
    "dropContext": "Сбросить контекст",
    "suggestedLabel": "Попробуйте спросить"
  },
  "tour": {
    "next": "Далее",
    "skip": "Пропустить",
    "done": "Готово",
    "step": "Шаг {{current}} / {{total}}",
    "search": {
      "title": "Поиск: {{unitPlural}}",
      "body": "Найдите любое место по названию. Нажмите на результат, чтобы перейти к нему."
    },
    "layer": {
      "title": "Слои карты",
      "body": "Переключайте вид карты: температура, цены, скорость интернета, иностранные сообщества и многое другое."
    },
    "poi": {
      "title": "Точки интереса",
      "body": "Включайте больницы, школы, транспорт, подъёмники и другие точки на карте."
    },
    "shortlist": {
      "title": "Ваши списки",
      "body": "Сохраняйте понравившиеся {{unitPlural}} в именованные списки с заметками — войдите, чтобы получить доступ с любого устройства."
    }
  },
  "scoring": {
    "profileFit": "Соответствие профилю",
    "changeProfile": "Сменить профиль",
    "weightTooltip": "Вес в этом профиле",
    "dimensions": {
      "climate": "Климат",
      "cost": "Стоимость жизни",
      "infra": "Инфраструктура",
      "foreign": "Экспат-сообщество",
      "tax": "Местный налог"
    },
    "presets": {
      "balanced": {
        "name": "Сбалансированный",
        "description": "Равный вес по всем факторам"
      },
      "family": {
        "name": "Семья с детьми",
        "description": "Школы, больницы и доступная цена"
      },
      "nomad": {
        "name": "Цифровой кочевник",
        "description": "Хороший интернет, мягкий климат, доступно"
      },
      "retiree": {
        "name": "Пенсионер",
        "description": "Медицина, мягкий климат, низкие налоги"
      },
      "mountain": {
        "name": "Горный энтузиаст",
        "description": "Высота, прохладное лето, снег"
      }
    }
  },
  "locale": {
    "show": "Показать",
    "hint": {
      "ru": "Доступен слой «Русскоязычные жители» — посмотрите, где ваша диаспора.",
      "ua": "Доступен слой «Украинские жители» — посмотрите распределение сообщества.",
      "de": "Доступен слой немецкоязычных жителей — полезно для Альто-Адидже."
    }
  },
  "map": {
    "meta": {
      "title": "Карта переезда: {{country}} — Lodestar",
      "description": "{{country}} на карте: стоимость жизни, аренда, климат и сервисы — вплоть до отдельного муниципалитета. Фильтруйте по приоритетам и сохраняйте подходящие места."
    },
    "quizBanner": {
      "label": "Фильтры из квиза активны",
      "reset": "Сбросить",
      "dismiss": "Закрыть"
    },
    "focusBanner": {
      "label_one": "{{count}} рекомендованная коммуна · {{region}}",
      "label_few": "{{count}} рекомендованные коммуны · {{region}}",
      "label_many": "{{count}} рекомендованных коммун · {{region}}",
      "label_other": "{{count}} рекомендованных коммун · {{region}}",
      "regionFallback": "вашему региону",
      "clear": "Сбросить",
      "label": "Фокус на вашем профиле из теста"
    },
    "backTo": {
      "recommendations": "К моим рекомендациям",
      "quizResult": "К результатам квиза",
      "countries": "К странам",
      "account": "К аккаунту"
    },
    "region": {
      "ariaLabel": "Интерактивная карта: {{country}}. Для скринридера: используйте панели фильтров, слоёв и POI."
    }
  },
  "nextSteps": {
    "title": "Переезд в Италию — следующие шаги",
    "titleCountry": "Переезд в {{country}} — следующие шаги",
    "subtitle": "Практический чеклист от решения до обустройства. Прогресс сохраняется локально.",
    "guide": {
      "eyebrow": "Полный гид по стране",
      "hubLink": "{{country}} — энциклопедия →",
      "visa": "Визы",
      "taxes": "Налоги",
      "cost": "Стоимость жизни",
      "banking": "Банки",
      "property": "Недвижимость",
      "healthcare": "Медицина"
    },
    "backToMap": "Назад к карте",
    "backToResult": "Назад к результатам квиза",
    "consultantPrompt": "Чеклист не отвечает на ваш вопрос? Мы познакомим с проверенным экспертом на месте.",
    "consultantLink": "Запросить знакомство →",
    "resources": "Ресурсы",
    "disclaimer": "Чеклист носит общий характер. Требования зависят от гражданства, типа визы и конкретного comune. Проконсультируйтесь с иммиграционным адвокатом.",
    "save": {
      "cta": "Сохранить чеклист",
      "placeholder": "ты@example.com",
      "submit": "Сохранить и прислать ссылку",
      "sending": "Сохраняем…",
      "cancel": "Отмена",
      "anonConfirm": "Проверьте почту — мы отправили одноразовую ссылку, чтобы вернуться к чеклисту с любого устройства.",
      "failed": "Не сохранено — письмо со ссылкой не ушло. Попробуйте ещё раз.",
      "authConfirm": "Сохранено — прогресс привязан к вашему аккаунту."
    },
    "print": {
      "cta": "Печать / PDF",
      "hint": "Откроет браузерный диалог печати — выберите «Save as PDF» для офлайн-копии."
    },
    "pdf": {
      "download": "Скачать PDF",
      "downloading": "Готовим…",
      "downloadHint": "Скачать брендированный PDF этого чеклиста",
      "downloadError": "Не удалось сгенерировать PDF. Попробуйте ещё раз.",
      "emailCta": "Прислать на почту",
      "emailHint": "Отправить PDF на ваш email",
      "emailPlaceholder": "you@example.com",
      "send": "Отправить",
      "sending": "Отправляем…",
      "emailSuccess": "Отправили на {{email}} — проверьте входящие.",
      "emailError": "Не удалось отправить письмо. Попробуйте ещё раз.",
      "emailRateLimited": "Слишком много отправлений с вашей сети. Подождите 15 минут.",
      "generatedFor": "Сгенерировано для {{recipient}} · {{date}}",
      "anonymous": "анонимного пользователя",
      "pageOf": "Страница {{page}} из {{total}}"
    },
    "resource": {
      "community": "сообщество",
      "official": "официально",
      "property": "поиск жилья",
      "banking": "банк",
      "health": "здоровье"
    },
    "phase": {
      "strategy": {
        "title": "Стратегическое планирование",
        "timeline": "за 6–12 месяцев"
      },
      "prep": {
        "title": "Подготовка",
        "timeline": "за 3–6 месяцев"
      },
      "logistics": {
        "title": "Логистика",
        "timeline": "за 1–3 месяца"
      },
      "arrival": {
        "title": "Прибытие",
        "timeline": "первый месяц"
      },
      "settle": {
        "title": "Обустройство",
        "timeline": "месяцы 2–6"
      }
    },
    "item": {
      "strategy": {
        "visa-research": "Изучить варианты виз для вашего гражданства",
        "lawyer": "Проконсультироваться с итальянским иммиграционным адвокатом",
        "language": "Начать итальянский язык (рекомендуется уровень A2)",
        "tax-home": "Разобраться с налоговыми последствиями на родине",
        "health-zone": "Проверить медицинское покрытие в выбранном comune (зона ASL)"
      },
      "prep": {
        "visa-apply": "Подать заявление на итальянскую визу в консульство",
        "codice-fiscale": "Получить Codice Fiscale в итальянском консульстве",
        "apartment-search": "Начать поиск жилья для долгосрочной аренды",
        "expat-connect": "Установить связь с экспат-сообществами в выбранном регионе",
        "health-insurance": "Оформить международную медицинскую страховку на переходный период"
      },
      "logistics": {
        "arrival-accommodation": "Забронировать временное жильё на 2–4 недели",
        "wise-revolut": "Открыть Wise или Revolut для операций в EUR",
        "docs-translation": "Подготовить нотариально заверенные переводы ключевых документов",
        "notify-home-bank": "Уведомить банк и налоговую на родине",
        "shipping": "Организовать доставку или хранение вещей"
      },
      "arrival": {
        "residenza": "Зарегистрироваться в comune (ufficio anagrafe) → получить residenza",
        "permesso": "Не-ЕС: подать на permesso di soggiorno в questura (в течение 8 дней с въезда)",
        "medico-base": "Прикрепиться к местному врачу (medico di base) в ASL",
        "bank-account": "Открыть итальянский банковский счёт (Fineco, Buddybank или онлайн)",
        "ssn": "Зарегистрироваться в системе национального здравоохранения (SSN)"
      },
      "settle": {
        "commercialista": "Найти бухгалтера (commercialista) для итальянской налоговой декларации",
        "driver-license": "Переоформить водительское удостоверение (если требуется)",
        "utilities": "Оформить коммунальные услуги: газ, электричество, интернет",
        "community": "Вступить в местные экспат-группы и интегрироваться в сообщество",
        "school": "Записать детей в школу (если применимо)",
        "property-tax-obligations": "Разобраться с налогами на недвижимость, если планируете покупку (IMU + регистрационный + прирост капитала)"
      }
    },
    "detail": {
      "prep": {
        "codice-fiscale": "Нужен практически везде: банк, аренда, медицина"
      },
      "arrival": {
        "permesso": "Просрочка влечёт штрафы; возьмите все документы в первый же день"
      },
      "settle": {
        "commercialista": "Даже простые налоговые ситуации в Италии часто требуют местного специалиста",
        "property-tax-obligations": "IMU на основное жильё освобождён; на второе жильё 0.5–1.06% кадастровой стоимости. Регистрационный налог 2% (основное) или 9% (второе). Прирост капитала 26% при продаже до 5 лет."
      }
    },
    "noData": "У нас пока нет чек-листа по релокации для страны {{country}}. Чек-листы есть для 9 стран: AE, PT, ES, CY, TH, MY, ID, GR, MU (плюс IT)."
  },
  "visitPlanner": {
    "title": "План поездки",
    "subtitle": "Оптимальный маршрут для {{count}} остановок.",
    "tooFew": "Выберите минимум 2 comuni для маршрута.",
    "tooMany": "Максимум 7 остановок. Вы выбрали {{count}}.",
    "computing": "Вычисляю маршрут…",
    "error": "Ошибка маршрута: {{msg}}",
    "drive": "В пути",
    "distance": "Расстояние",
    "stops": "Остановки",
    "openGmaps": "Открыть в Google Maps",
    "downloadGpx": "Скачать GPX",
    "markVisited": "Отметить как посещённое",
    "markUnvisited": "Снять отметку",
    "youAreHere": "Вы здесь",
    "nextStop": "Следующая остановка",
    "imHere": "📍 Я здесь",
    "locating": "Определяю местоположение…",
    "premiumBadge": "бесплатно",
    "unlockTitle": "Режим «Я здесь»",
    "unlockDesc": "Геолокация + навигация к следующей остановке одним касанием. Бесплатно, без карты.",
    "unlockBenefitsTitle": "Что вы получаете",
    "unlockBenefit1": "Живая отметка вашей геолокации на карте",
    "unlockBenefit2": "Автоматическое определение ближайшей следующей остановки",
    "unlockBenefit3": "Открытие маршрута в Apple Maps / Google Maps одним касанием",
    "unlockBenefit4": "Галочки «посещено», синхронизируемые между устройствами при входе",
    "unlockWhyEmail": "Зачем email: одноразовая ссылка, чтобы вернуться в этот режим с другого устройства и сохранить историю маршрутов. Никакого spam — отписка в каждом письме.",
    "unlockPlaceholder": "you@example.com",
    "unlockBtn": "Разблокировать бесплатно",
    "unlockSending": "Открываем…",
    "unlockFailed": "Режим не открылся — письмо со ссылкой не ушло. Попробуйте ещё раз.",
    "unlockCancel": "Отмена"
  },
  "story": {
    "back": "Назад",
    "backHome": "Вернуться в Lodestar →",
    "title": "Поделитесь историей переезда",
    "intro": "Достаточно двух предложений. Что сработало, что удивило, что бы вы сказали себе год назад? Принятые истории — анонимные по умолчанию — становятся материалом, который помогает следующим.",
    "email": "Email",
    "country": "Страна (опционально)",
    "countryPlaceholder": "— выбери страну —",
    "body": "Ваша история",
    "placeholder": "напр. «Переехал в Тренто весной 2026 по DNV. Самое сложное — запись на codice fiscale, бронировал за 2 месяца. Приятный сюрприз: аренда на 30% дешевле моего бюджета.»",
    "publishOk": "Можно опубликовать анонимно (вы увидите финальную версию до публикации).",
    "submit": "Поделиться историей",
    "sending": "Отправляем…",
    "thanksTitle": "Спасибо — прочитаем лично.",
    "thanksBody": "Мы отправили вам подтверждение на почту. Если решим опубликовать (анонимно по умолчанию), свяжемся в течение десяти рабочих дней.",
    "networkError": "Ошибка сети."
  },
  "consultant": {
    "back": "Назад",
    "backHome": "Вернуться в Lodestar →",
    "title": "Поговорить с экспертом по переезду",
    "intro": "Расскажите, что нужно — подберём специалиста, как только наша сеть будет готова. Комиссию с вас не берём.",
    "email": "Email",
    "telegram": "Telegram (необязательно — для быстрой связи)",
    "telegramPlaceholder": "@username или номер телефона",
    "context": "Контекст:",
    "country": "Страна",
    "countryPlaceholder": "Выбери страну…",
    "category": "По вопросу",
    "timeline": "Когда?",
    "planningToBuyLabel": "Планируете покупку недвижимости?",
    "planningToBuy": {
      "yes": "Да",
      "no": "Только аренда",
      "unsure": "Пока не решил(а)"
    },
    "planningToBuyYesNote": "Хорошо — подберём специалиста с опытом в налогах на недвижимость и работе с нотариусом для этой страны.",
    "notes": "Одно предложение о том, что нужно (опционально)",
    "notesPlaceholder": "напр. «Подаюсь на DNV, нужен commercialista в Тренто, работающий с не-ЕС.»",
    "submit": "Запросить знакомство",
    "sending": "Отправляем…",
    "thanksTitle": "Заявка получена — свяжемся.",
    "thanksBody": "Мы сейчас формируем сеть специалистов. Как только найдём кого-то под вашу страну и тему — напишем. Если совпадения не будет, скажем напрямую.",
    "networkError": "Ошибка сети.",
    "partnerCta": {
      "title": "Вы консультант?",
      "body": "Получайте проверенные заявки на переезд — присоединяйтесь к нашей партнёрской программе.",
      "button": "Партнёрская программа →"
    },
    "consentRequired": "Подтвердите согласие перед отправкой.",
    "consent": {
      "share": "Я согласен, что Lodestar может передать мои контактные данные одному или нескольким проверенным партнёрам-консультантам для оказания запрошенной услуги. Согласие можно отозвать в любой момент, написав на hello@lodestar.place.",
      "privacyLink": "Политика конфиденциальности"
    },
    "cat": {
      "visa": "Виза и иммиграция",
      "tax": "Налоги и бухгалтерия",
      "real-estate": "Недвижимость",
      "translation": "Перевод и документы",
      "other": "Что-то другое"
    },
    "tl": {
      "this_month": "В этом месяце",
      "this_quarter": "В этом квартале",
      "this_year": "В этом году",
      "exploring": "Пока просто изучаю"
    }
  },
  "feedback": {
    "openLabel": "Отзыв",
    "openTitle": "Отправить отзыв",
    "errorRateLimit": "Слишком много обращений. Попробуйте позже.",
    "errorGeneric": "Не получилось отправить. Попробуйте снова.",
    "category": "Категория",
    "email": "Email (по желанию, для ответа)",
    "message": "Сообщение",
    "placeholder": "Что произошло, где, и чего вы ожидали?",
    "send": "Отправить",
    "sending": "Отправляем…",
    "subtitle": "Нашли ошибку, не хватает данных или есть идея? Расскажите нам.",
    "thanks": "Спасибо! Мы читаем каждое сообщение.",
    "title": "Оставить отзыв",
    "tooShort": "Добавьте хотя бы одно предложение."
  },
  "partners": {
    "eyebrow": "Партнёрская программа",
    "hero": {
      "title": "Получайте проверенные заявки на переезд — без рекламы.",
      "body": "Lodestar помогает русскоязычным эмигрантам выбрать страну для переезда. Когда им нужен человек — иммиграционный юрист, налоговый консультант, риелтор — мы направляем их к проверенным партнёрам. Подайте заявку, чтобы войти в сеть.",
      "ctaPrimary": "Подать заявку",
      "ctaSecondary": "Как это работает"
    },
    "why": {
      "title": "Зачем партнёриться с Lodestar",
      "audience": {
        "title": "Подготовленная аудитория",
        "body": "Наш квиз оценивает пользователя по 7 параметрам ещё до запроса консультации — вам не нужно тратить первый звонок на проверку того, подходит ли вообще страна."
      },
      "intent": {
        "title": "Реальный сигнал намерения",
        "body": "В каждой заявке — сроки, бюджетный сигнал (планирует покупку?), категория. Вы решаете принять/отклонить до любой оплаты."
      },
      "compliance": {
        "title": "Соответствие GDPR",
        "body": "Получаем явное согласие пользователя перед передачей контактов. Вы подписываете DPA, мы храним аудит-логи. Никаких серых схем."
      },
      "reputation": {
        "title": "Доверие через ассоциацию",
        "body": "Lodestar позиционируется как вдумчивый и методологичный ресурс. Проверенные партнёры разделяют это позиционирование в своём публичном профиле."
      }
    },
    "how": {
      "title": "Как это работает",
      "s1": {
        "title": "Подайте заявку",
        "body": "Заполните форму из 4 шагов — займёт около 6 минут. Расскажите, где вы работаете, на чём специализируетесь, и оставьте ссылки на ваш сайт или соцсети."
      },
      "s2": {
        "title": "Пройдите верификацию",
        "body": "Мы лично проверяем каждую заявку — регистрация компании, лицензия (если применимо), референсы. Бейдж Verified открывает доступ к лидам."
      },
      "s3": {
        "title": "Получайте подобранные лиды",
        "body": "Пользователи проходят квиз и запрашивают знакомство по вашей стране + категории. Вы видите бриф и решаете, брать ли его."
      },
      "s4": {
        "title": "Платите только за принятые лиды",
        "body": "На MVP — без подписки, плата за принятие от $15 за подобранное знакомство. Возврат за невалидные контакты в течение 48 часов."
      }
    },
    "tiers": {
      "title": "Уровни верификации",
      "intro": "Три уровня — по объёму того, что мы проверили. Высокие уровни получают приоритет в маршрутизации и попадают в публичный каталог.",
      "basic": {
        "badge": "Listed",
        "title": "Basic",
        "price": "Бесплатно",
        "f1": "Только листинг, без лидов",
        "f2": "Ручная проверка сайта + LinkedIn"
      },
      "verified": {
        "badge": "✓ Verified",
        "title": "Verified",
        "price": "$99 единоразово",
        "f1": "Документы юр.лица + 15-минутное видеоинтервью",
        "f2": "Получение лидов, оплата за принятие",
        "f3": "Размещение в каталоге"
      },
      "pro": {
        "badge": "★ Pro Verified",
        "title": "Pro Verified",
        "price": "$99 + $19/мес",
        "f1": "Профессиональная лицензия + страховка",
        "f2": "Топ-размещение, эксклюзивные лиды",
        "f3": "Отзывы клиентов на профиле"
      },
      "note": "Цены MVP — только pay-per-acceptance; подписочные тарифы появятся в Фазе 1 после набора ликвидности."
    },
    "cta": {
      "title": "Готовы получить первый лид?",
      "body": "Заявка занимает около 6 минут. Отвечаем в течение 5 рабочих дней. Первые 10 founding-партнёров — 90 дней бесплатно.",
      "button": "Подать заявку"
    },
    "footer": {
      "terms": "Партнёрское соглашение",
      "dpa": "Соглашение об обработке данных",
      "faq": "FAQ"
    },
    "apply": {
      "back": "Назад",
      "title": "Заявка партнёра",
      "intro": "Четыре коротких шага. Около 6 минут. Черновик сохраняется автоматически.",
      "progressLabel": "Прогресс заявки",
      "next": "Далее →",
      "submit": "Отправить заявку",
      "submitting": "Отправляем…",
      "backHome": "Вернуться в Lodestar →",
      "thanksEyebrow": "Заявка получена",
      "thanksTitle": "Спасибо — мы свяжемся.",
      "thanksBody": "Модератор Lodestar лично прочитает вашу заявку. Ответ в течение 5 рабочих дней — следите за почтой, могут быть уточняющие вопросы.",
      "step": {
        "1": {
          "label": "Контакт"
        },
        "2": {
          "label": "Специализация"
        },
        "3": {
          "label": "Опыт"
        },
        "4": {
          "label": "Согласия"
        }
      },
      "fullName": "Полное имя",
      "email": "Email",
      "phone": "Телефон (опционально)",
      "telegram": "Telegram / WhatsApp (опционально)",
      "residenceCountry": "Страна резидентства",
      "countryPlaceholder": "Выбрать страну…",
      "countryOther": "Другая / не в списке",
      "entityType": "Вы",
      "entityPlaceholder": "Выбрать тип…",
      "entity": {
        "individual": "Индивидуальный консультант",
        "sole_prop": "ИП / самозанятый",
        "company": "Компания / ООО",
        "law_firm": "Юридическая фирма",
        "agency": "Релокейшн-агентство"
      },
      "legalStatus": "Юридический статус / регистрация",
      "legalStatusHint": "напр. «ИП в РФ», «Self-employed (Portugal)», «LLC, Estonia OÜ» — свободный текст.",
      "categories": "Категории услуг",
      "cat": {
        "visa": "Виза",
        "tax": "Налоги",
        "real_estate": "Недвижимость",
        "translation": "Переводы",
        "relocation_general": "Релокейшн (общий)",
        "business_setup": "Открытие компании",
        "banking": "Банкинг",
        "education": "Образование",
        "healthcare": "Здравоохранение",
        "other": "Другое"
      },
      "targetCountries": "Страны, по которым консультируете",
      "languages": "Языки общения с клиентом",
      "yearsExperience": "Опыт работы",
      "yearsPlaceholder": "Выбрать диапазон…",
      "years": {
        "lt_1": "Менее 1 года",
        "1_3": "1–3 года",
        "3_5": "3–5 лет",
        "5_10": "5–10 лет",
        "gt_10": "10+ лет"
      },
      "websiteUrl": "Сайт (опционально)",
      "linkedinUrl": "LinkedIn (опционально)",
      "socialUrl": "Другая соцсеть (опционально)",
      "linksHint": "Минимум одна из трёх ссылок выше обязательна — мы используем её для верификации вашей работы.",
      "bio": "О себе / компании",
      "bioHint": "От 200 до 1500 символов. Опишите типичных клиентов, географию работы, языки.",
      "estClientsPerYear": "Клиентов в год (опционально)",
      "referralSource": "Откуда узнали о нас? (опционально)",
      "consentIntro": "Перед тем как принять заявку, подтвердите следующее. Версия каждого документа фиксируется в момент согласия — вы можете запросить точный текст, который приняли, в любой момент.",
      "consent": {
        "terms": "Я принимаю ",
        "termsLink": "Партнёрское соглашение",
        "privacy": "Я согласен с обработкой моих ПДн в соответствии с ",
        "privacyLink": "Политикой конфиденциальности",
        "dpa": "Я подпишу ",
        "dpaLink": "Соглашение об обработке данных",
        "dpaTail": " перед получением первого лида.",
        "confidentiality": "Я обязуюсь относиться ко всем данным клиентов, полученным через Lodestar, как к конфиденциальным и использовать их только для оказания запрошенной услуги.",
        "marketing": "Присылать мне обновления по партнёрской программе (опционально)."
      },
      "errors": {
        "fullName": "Введите полное имя.",
        "email": "Введите корректный email.",
        "residenceCountry": "Выберите страну резидентства.",
        "entityType": "Выберите тип.",
        "legalStatus": "Опишите юридический статус.",
        "categories": "Выберите хотя бы одну категорию.",
        "targetCountries": "Выберите хотя бы одну страну.",
        "languages": "Выберите хотя бы один язык.",
        "yearsExperience": "Выберите диапазон опыта.",
        "anyLink": "Укажите хотя бы одну ссылку (сайт, LinkedIn или соцсеть).",
        "bioMin": "Описание должно быть не короче 200 символов.",
        "bioMax": "Описание слишком длинное (макс 1500 символов).",
        "consentRequired": "Требуется для продолжения.",
        "fixSteps": "На предыдущих шагах есть незаполненные поля. Вернитесь и исправьте.",
        "rateLimit": "Слишком много отправок. Попробуйте позже.",
        "network": "Ошибка сети. Попробуйте снова."
      }
    },
    "terms": {
      "back": "Партнёрская программа",
      "title": "Партнёрское соглашение",
      "version": "Версия: 2026-05-26 — черновик, ожидает проверки юриста",
      "disclaimer": "Это структурный черновик, опубликованный вместе с формой заявки, чтобы потенциальные партнёры могли видеть состав документа. Финальный обязывающий текст будет разослан одобренным партнёрам для подписи после регистрации операционного юр.лица.",
      "s1": {
        "body": "Настоящее соглашение заключается между Lodestar (юридическим лицом, управляющим lodestar.place; юрисдикция будет подтверждена при регистрации компании) и консультантом или фирмой, утверждёнными в качестве Партнёра.",
        "title": "1. Стороны"
      },
      "s2": {
        "body": "Lodestar направляет Партнёру квалифицированные запросы по релокации с учётом страны, категории услуги и языкового покрытия. Партнёр отвечает за оказание запрошенных консультационных услуг конечным пользователям на собственных условиях.",
        "title": "2. Сфера действия"
      },
      "s3": {
        "body": "Партнёр уплачивает Lodestar комиссию за каждый принятый лид, размер которой раскрывается в момент предложения лида. На этапе MVP подписка не требуется. Оплата выставляется через Stripe Connect после его подключения; партнёры-основатели получают 90 дней бесплатно или первые 20 принятых лидов — в зависимости от того, что наступит раньше.",
        "title": "3. Комиссии и оплата"
      },
      "s4": {
        "body": "Партнёр рассматривает все данные конечных пользователей, полученные через платформу, как строго конфиденциальные и не использует их в каких-либо целях, кроме оказания запрошенной услуги. Дальнейшая передача субобработчикам требует письменного уведомления Lodestar.",
        "title": "4. Конфиденциальность"
      },
      "s5": {
        "body": "Партнёр обязуется не привлекать конечных пользователей, представленных через Lodestar, к услугам в обход платформы в период активного сотрудничества и в течение 12 месяцев после него.",
        "title": "5. Запрет обхода платформы"
      },
      "s6": {
        "body": "Обе стороны соблюдают применимое законодательство о защите данных (GDPR или эквивалент). Технические и организационные меры регулируются отдельным Соглашением об обработке данных.",
        "title": "6. Защита данных"
      },
      "s7": {
        "body": "Любая сторона вправе расторгнуть настоящее соглашение в любой момент с письменным уведомлением за 30 дней. Lodestar вправе приостановить или расторгнуть его незамедлительно при существенном нарушении (мошенничество, злоупотребление данными пользователей, неоднократные нарушения SLA).",
        "title": "7. Расторжение"
      },
      "s8": {
        "body": "Lodestar предоставляет услугу подбора лидов «как есть» и не является стороной консультационных отношений между Партнёром и конечным пользователем. Lodestar не несёт ответственности за результат консультационных услуг.",
        "title": "8. Ответственность"
      },
      "s9": {
        "body": "Настоящее соглашение регулируется правом юрисдикции, в которой зарегистрирована Lodestar. Споры разрешаются в компетентных судах этой юрисдикции.",
        "title": "9. Применимое право"
      }
    },
    "dpa": {
      "back": "Партнёрская программа",
      "title": "Соглашение об обработке данных",
      "version": "Версия: 2026-05-26 — черновик, ожидает проверки юриста",
      "disclaimer": "Это структурный черновик. Финальный DPA будет приведён в соответствие со Стандартными договорными положениями, модуль 1 (controller-to-controller), и проверен юристом перед подписью.",
      "s1": {
        "body": "Lodestar выступает Контролёром данных конечных пользователей, собранных через платформу, до момента принятия лида Партнёром. После принятия Партнёр становится самостоятельным Контролёром переданных ему данных и обрабатывает их в собственных консультационных целях.",
        "title": "1. Роли"
      },
      "s10": {
        "body": "Lodestar вправе при разумном уведомлении и не чаще одного раза в год запрашивать сведения о соблюдении Партнёром настоящего DPA. Выездные проверки могут проводиться за счёт Lodestar в случаях, когда отсутствуют независимые сертификаты (ISO 27001 или эквивалент).",
        "title": "10. Аудит"
      },
      "s2": {
        "body": "Идентификация: полное имя, email, по желанию телефон. Профильные сигналы: целевая страна, категория услуги, сроки, язык. Особые категории данных (GDPR ст. 9) не обрабатываются.",
        "title": "2. Категории данных"
      },
      "s3": {
        "body": "Обработка осуществляется на основании явного согласия конечного пользователя (GDPR ст. 6(1)(a)) и в целях оказания запрошенной пользователем услуги по установлению контакта (ст. 6(1)(b)). Конечные пользователи вправе отозвать согласие в любой момент, после чего Партнёр прекращает обработку соответствующих данных, если отсутствует самостоятельное правовое основание.",
        "title": "3. Цель и правовое основание"
      },
      "s4": {
        "body": "Lodestar использует следующих субобработчиков: Cloudflare (D1, R2, Workers, хостинг), Resend (транзакционная почта), Sentry (мониторинг ошибок). Партнёр ведёт аналогичный перечень собственных субобработчиков и уведомляет Lodestar об изменениях, затрагивающих данные, поступившие от Lodestar.",
        "title": "4. Субобработчики"
      },
      "s5": {
        "body": "При передаче персональных данных за пределы Европейской экономической зоны такие передачи защищаются Стандартными договорными положениями (SCC) и дополнительными мерами по мере необходимости.",
        "title": "5. Международные передачи данных"
      },
      "s6": {
        "body": "Обе стороны поддерживают разумные технические и организационные меры, включая: шифрование при передаче (TLS) и при хранении, доступ по принципу служебной необходимости, многофакторную аутентификацию для административного доступа, регулярное резервное копирование и процесс реагирования на инциденты. IP-адреса Lodestar не хранит (только cf-ipcountry).",
        "title": "6. Меры безопасности"
      },
      "s7": {
        "body": "Партнёр содействует Lodestar в ответах на запросы субъектов данных (доступ, исправление, удаление, переносимость, возражение) в установленные законом сроки. Партнёр не отвечает напрямую конечному пользователю, поступившему от Lodestar, без предварительного уведомления Lodestar.",
        "title": "7. Права субъектов данных"
      },
      "s8": {
        "body": "Каждая сторона уведомляет другую без неоправданной задержки и в любом случае в течение 72 часов с момента, когда ей стало известно о нарушении в отношении персональных данных, затрагивающем данные, поступившие от другой стороны.",
        "title": "8. Уведомление о нарушениях"
      },
      "s9": {
        "body": "Партнёр хранит данные конечных пользователей лишь столько, сколько необходимо для оказания запрошенной услуги и выполнения требований закона (как правило, 24 месяца с момента завершения). При расторжении Партнёрского соглашения Партнёр удаляет или возвращает все персональные данные, поступившие от Lodestar, в течение 30 дней, за исключением случаев, когда хранение требуется по закону.",
        "title": "9. Хранение и удаление"
      }
    },
    "faq": {
      "back": "Партнёрская программа",
      "title": "FAQ для партнёров",
      "intro": "Частые вопросы от потенциальных партнёров. Чего-то не хватает? Напишите на partners@lodestar.place."
    }
  },
  "topics": {
    "landing": {
      "headlineFmt": "{{topic}} по 39 странам",
      "descriptionFmt": "Сравнение «{{topic}}» страна за страной. Опубликовано {{published}} глав; остальные в плане.",
      "home": "Lodestar",
      "crumb": "Темы",
      "published": "Опубликованные главы",
      "publishedEmpty": "Пока ни одной главы. Италия, наш редакционный флагман — главы появляются здесь по мере выхода.",
      "coming": "Следующие на очереди",
      "readChapter": "Открыть главу",
      "others": "Другие темы",
      "ctaQuiz": "Пройти квиз →",
      "ctaAtlas": "Открыть атлас →",
      "notFoundTitle": "Тема не найдена",
      "notFoundSub": "Выберите измерение с главной страницы, чтобы увидеть все главы и страны.",
      "notFoundCta": "Вернуться на главную"
    },
    "index": {
      "meta": {
        "title": "Темы релокации — сравнение 39 стран",
        "description": "Релокация по темам: визы, налоги, стоимость жизни, климат, медицина, школы, безопасность и язык — сравнение по всем 39 странам атласа Lodestar."
      },
      "sub": "Выберите измерение, чтобы увидеть, как сравниваются 31 страна — сначала опубликованные гайды, полное покрытие в пути.",
      "title": "Просмотр по темам"
    }
  },
  "wiki": {
    "atlas": "Атлас",
    "hub": {
      "metaTitle": "{{country}} — путеводитель для переезда: визы, налоги, стоимость жизни",
      "metaDescription": "Спокойный путеводитель по стране {{country}} для тех, кто всерьёз думает о переезде: визы, налоги, стоимость жизни, климат, медицина, школы, банки.",
      "tagline": "Путеводитель для переезда",
      "snapshotTitle": "Кратко",
      "snapshotIntro": "Семь измерений жизни на одной карточке.",
      "topicsTitle": "Главы",
      "topicsIntro": "В каждой — ответ на один реальный вопрос.",
      "annualTitle": "Год в стране {{country}}",
      "annualIntro": "Климат, продление документов, заметные события.",
      "neighborsTitle": "Сравнить с соседями",
      "neighborsIntro": "Три страны того же региона рядом.",
      "ctaQuiz": "Сопоставить с моими приоритетами",
      "ctaChecklist": "Открыть чек-лист переезда",
      "ctaMap": "Открыть интерактивную карту",
      "ctaGuide": "Как пользоваться картой →",
      "lastVerified": "Проверено {{date}}",
      "comingSoonContent": "Длинные главы появляются по мере того, как заканчивается ресёрч. То, что вы видите — это структура; контент наполняется страна за страной.",
      "draftBadge": "Черновик",
      "publishedGuidesTitle": "Сравни с другими странами",
      "publishedGuidesIntro": "Полные гайды по релокации для похожих направлений."
    },
    "topic": {
      "visa": {
        "label": "Визы",
        "description": "Маршруты, сроки, документы"
      },
      "taxes": {
        "label": "Налоги",
        "description": "Ставки, режимы, соглашения"
      },
      "cost-of-living": {
        "label": "Стоимость жизни",
        "description": "Аренда, продукты, сервисы"
      },
      "property": {
        "label": "Недвижимость",
        "description": "Покупка, владение, налоги на жильё"
      },
      "climate": {
        "label": "Климат",
        "description": "Температура, влажность, солнце круглый год"
      },
      "healthcare": {
        "label": "Медицина",
        "description": "Гос. и частная, реальные расходы"
      },
      "education": {
        "label": "Образование",
        "description": "Школы, детсады, экспат-варианты"
      },
      "banking": {
        "label": "Банки и счета",
        "description": "Открытие, SWIFT, резидентство"
      },
      "transport": {
        "label": "Транспорт",
        "description": "Машина, права, общественный транспорт"
      },
      "safety-community": {
        "label": "Безопасность и сообщество",
        "description": "Криминал, экспат-сети, поддержка"
      },
      "language-culture": {
        "label": "Язык и культура",
        "description": "Что учить обязательно, а что нет"
      },
      "infrastructure": {
        "label": "Инфраструктура",
        "description": "Интернет, ЖКХ, бытовая логистика"
      }
    },
    "article": {
      "tocLabel": "Содержание",
      "faqTitle": "Часто спрашивают",
      "relatedTopics": "Связанные главы",
      "compareWithNeighbours": "Сравнить с соседями",
      "backToHub": "К стране {{country}}",
      "verifiedAt": "Проверено {{date}}",
      "byAuthor": "автор: {{author}}",
      "nextChapter": "Следующая глава",
      "prevChapter": "Предыдущая глава",
      "allTopics": "Все главы"
    },
    "breadcrumb": {
      "atlas": "Атлас"
    },
    "notFound": {
      "title": "Страница не найдена",
      "subtitle": "Страна или раздел, который вы открыли, пока не существует.",
      "ctaAtlas": "Вернуться в Атлас"
    }
  },
  "guide": {
    "label": "Руководство",
    "metaDescription": "Руководство Lodestar — практические статьи о том, как пользоваться картой, пинами, шортлистом, таблицей сравнения и AI-помощником при выборе места для жизни.",
    "rootTag": "Документация",
    "sectionTag": "Раздел",
    "articleCount": "{{count}} статья",
    "articleCount_few": "{{count}} статьи",
    "articleCount_many": "{{count}} статей",
    "articleCount_other": "{{count}} статей",
    "emptySection": "Статьи этого раздела готовятся.",
    "relatedArticles": "По теме",
    "helpButton": {
      "aria": "Открыть {{label}}",
      "title": "Как пользоваться картой",
      "openAll": "Открыть всё руководство →"
    },
    "section": {
      "gettingStarted": {
        "label": "С чего начать",
        "description": "Что такое карта, что доступно без аккаунта и как провести на ней первые пять минут."
      },
      "useCases": {
        "label": "Сценарии",
        "description": "Конкретные задачи, которые карта закрывает — поиск жилья, климат, семья, налоги и не только."
      },
      "workflows": {
        "label": "Маршруты",
        "description": "Сцепки из нескольких сценариев, которые ведут от первого клика до решения о переезде."
      },
      "reference": {
        "label": "Справочник",
        "description": "По одной статье на каждый инструмент: фильтры, слои, пины, шортлист, сравнение, заметки, маршрут."
      },
      "faq": {
        "label": "Вопросы",
        "description": "Быстрые ответы на то, что спрашивают чаще всего."
      }
    },
    "article": {
      "what-is-the-map": {
        "title": "Зачем нужна карта",
        "summary": "Рабочая поверхность, чтобы сузить семь с лишним тысяч локаций до двух-трёх реальных кандидатов."
      },
      "first-five-minutes": {
        "title": "Первые пять минут на карте",
        "summary": "Открываете карту, привыкаете к данным и уходите с одним шортлистом."
      },
      "guest-vs-account": {
        "title": "Гость и аккаунт",
        "summary": "Что доступно без входа и что появляется после логина."
      },
      "filters-panel": {
        "title": "Панель фильтров",
        "summary": "Климат, инфраструктура, высота, население — ручки, которыми вы сужаете карту."
      },
      "choropleth-layers": {
        "title": "Тематические слои",
        "summary": "Как читать цветовую заливку, которая раскладывает одну метрику по всей территории."
      },
      "poi-layers": {
        "title": "Слои объектов",
        "summary": "Больницы, станции, аэропорты — точки, которые лежат поверх базовой карты."
      },
      "details-panel": {
        "title": "Панель деталей",
        "summary": "Что открывается по клику: двадцать две метрики, источники и кнопки рядом с ними."
      },
      "pins": {
        "title": "Пины",
        "summary": "Личные закладки на координатах — для объявлений, мест после поездки или напоминаний."
      },
      "bulk-import": {
        "title": "Массовый импорт",
        "summary": "Вставляете список адресов — карта геокодирует их и расставляет пины одним проходом."
      },
      "shortlist": {
        "title": "Шортлист",
        "summary": "Именованные подборки локаций с заметками — можно делиться и выгружать."
      },
      "annotations": {
        "title": "Заметки",
        "summary": "Стикеры на карте после поездки или разговора по телефону."
      },
      "compare-table": {
        "title": "Таблица сравнения",
        "summary": "До пяти локаций бок о бок по двадцати двум метрикам — лучшие и худшие подсвечены."
      },
      "visit-planner": {
        "title": "Планировщик поездки",
        "summary": "Шортлист превращается в маршрут до семи остановок."
      },
      "ai-helper": {
        "title": "AI-помощник",
        "summary": "Небольшой ассистент в углу карты, который видит ваш шортлист и отвечает на вопросы."
      },
      "real-estate-listings": {
        "title": "Сохранение объявлений о недвижимости",
        "summary": "Превращаем вкладку с объявлениями в карту кандидатов, которые можно сравнить."
      },
      "climate-search": {
        "title": "Поиск места по климату",
        "summary": "Мягкая зима, сухое лето, много солнца — превращаем предпочтения в карту со сжатым выбором."
      },
      "family-relocation": {
        "title": "Переезд с семьёй",
        "summary": "Школы, больницы, аэропорт неподалёку и сообщество, в которое можно встроиться."
      },
      "remote-work": {
        "title": "Удалённая работа из новой точки",
        "summary": "Скорость интернета, стоимость жизни и аэропорт — три ножки удалённого стола."
      },
      "retirement": {
        "title": "Место для пенсии",
        "summary": "Климат, медицина и налоговые режимы, заточенные под доход на пенсии."
      },
      "tax-optimization": {
        "title": "Сравнение по налогам",
        "summary": "Подоходный, на недвижимость, стоимость владения автомобилем — всё в одном поле зрения."
      },
      "lifestyle-fit": {
        "title": "Поиск по образу жизни",
        "summary": "Горы или побережье, большой город или маленький — сначала география, потом цифры."
      },
      "visa-pathway": {
        "title": "Фильтрация по визовой совместимости",
        "summary": "Сужаем карту до мест, которые принимают именно ваш паспорт."
      },
      "scouting-trip": {
        "title": "Поездка на разведку",
        "summary": "Превращаем шортлист в маршрут, забираем оффлайн, помечаем то, что увидели."
      },
      "final-decision": {
        "title": "Финальный выбор",
        "summary": "Три-пять финалистов, одна таблица, одна распечатка, один разговор."
      },
      "quiz-to-decision": {
        "title": "От квиза до решения",
        "summary": "Полный путь: квиз, сужение на карте, сравнение, выбор."
      },
      "listings-to-shortlist": {
        "title": "От вкладки с объявлениями до шортлиста",
        "summary": "Вставляете ссылки, карта группирует их в кластер, который имеет смысл проехать."
      },
      "scouting-to-checklist": {
        "title": "От разведки до чек-листа переезда",
        "summary": "Помечаете то, что увидели, доводите шортлист и переходите в чек-лист переезда."
      },
      "common-questions": {
        "title": "Частые вопросы",
        "summary": "Короткие ответы про пины, шортлист, синхронизацию и оффлайн."
      }
    },
    "notFound": {
      "title": "Страница не найдена",
      "subtitle": "Этой страницы в руководстве пока нет.",
      "cta": "Назад в Руководство"
    }
  },
  "consultantCta": {
    "eyebrow": "Живая помощь",
    "button": "Поговорить с консультантом",
    "home": {
      "title": "Хотите, чтобы человек провёл вас через это?",
      "body": "Запишитесь на 30-минутный звонок с экспертом по релокации. Выбор страны, визовый путь, реалистичные расходы — обсудим."
    },
    "quiz_result": {
      "title": "Нужен взгляд со стороны на эти результаты?",
      "body": "Консультант по релокации проверит топ-3 под вашу конкретную ситуацию — налоги, семья, работа."
    },
    "recommendations": {
      "title": "Никак не выбрать между регионами?",
      "body": "Поговорите с консультантом, который знает Италию изнутри — составит шорт-лист из 2–3 вариантов для поездки."
    },
    "compare_empty": {
      "title": "Пропустить сравнение и сразу к делу?",
      "body": "Консультант подготовит сравнительную таблицу под ваш бюджет, климат и семью за одну сессию."
    },
    "compare_active": {
      "title": "Выберите место для первого визита",
      "body": "Консультант поможет расставить приоритеты для посещения и укажет на детали переезда в рассматриваемые коммуны."
    },
    "next_steps": {
      "title": "Хотите, чтобы кто-то вёл эти шаги вместе с вами?",
      "body": "Запишитесь к консультанту — превратим этот чеклист в план с датами."
    },
    "quiz_result_passport": {
      "title": "Ограничения паспорта? Поговорите со специалистом.",
      "body": "Иммиграционные юристы, знакомые с вашим паспортом, помогут обойти банковские блокировки и визовые ограничения."
    },
    "quiz_result_buyer": {
      "title": "Покупаете недвижимость? Найдите юриста по недвижимости.",
      "body": "Покупка за рубежом — это нотариус, налоговая регистрация и сборы при передаче. Нужен тот, кто уже это делал."
    },
    "country_hub": {
      "title": "Готовы поговорить со страновым консультантом?",
      "body": "Консультант ответит на вопросы, которые ни одна статья не закроет — ваши сроки, расходы и первые шаги."
    },
    "topic_visa": {
      "title": "Готовы подавать документы? Поговорите с иммиграционным юристом.",
      "body": "Юрист проверит пригодность, подготовит пакет и укажет на риски отказа до подачи заявки."
    },
    "topic_taxes": {
      "title": "Налоги — нюансная тема. Проверьте свою ситуацию с бухгалтером.",
      "body": "Местный бухгалтер сопоставит ваши доходы с реальными ставками и договорами об избежании двойного налогообложения."
    },
    "topic_cost-of-living": {
      "title": "Хотите реалистичный бюджет под вашу ситуацию?",
      "body": "Консультант, который сам там живёт, даст честные цифры — а не средние по стране."
    },
    "topic_property": {
      "title": "Покупаете или арендуете? Нужен юрист по недвижимости.",
      "body": "Процесс покупки, нотариус, налоги, подводные камни — юрист защитит от дорогостоящих сюрпризов."
    },
    "topic_climate": {
      "title": "Помочь выбрать правильный регион?",
      "body": "Консультант, живущий там, скажет, какие районы действительно соответствуют вашим предпочтениям."
    },
    "topic_healthcare": {
      "title": "Страховка — то, в чём чаще всего ошибаются переезжающие.",
      "body": "Брокер подберёт полис, который реально защищает: регистрация, частные дополнения, стоматология, семья."
    },
    "topic_education": {
      "title": "Школы для детей? Поговорите с образовательным консультантом.",
      "body": "Доступность международных школ, языковые потоки и сроки приёма варьируются сильнее, чем пишут в статьях."
    },
    "topic_banking": {
      "title": "Открытие счёта иностранцем может занять недели.",
      "body": "Банковский советник знает, какие банки открывают счета с вашим паспортом и какие документы взять."
    },
    "topic_transport": {
      "title": "Обмен прав, регистрация авто — найдите того, кто это делал.",
      "body": "Местный помощник разберётся с бюрократией и сэкономит вам недели."
    },
    "topic_safety-community": {
      "title": "Выберите район с тем, кто там живёт.",
      "body": "Консультант даст честную картину безопасности и экспат-сообщества — лучше, чем любая статистика."
    },
    "topic_language-culture": {
      "title": "Найдите репетитора или коуча по культурной интеграции.",
      "body": "Язык и культурная интеграция — главные факторы долгосрочного счастья в новой стране. Начните раньше."
    },
    "topic_infrastructure": {
      "title": "Интернет, коммуналка, бумаги — найдите местного помощника.",
      "body": "Координатор переезда знает местный рынок провайдеров и наладит быт с первого дня."
    },
    "checklist_strategy": {
      "title": "Выберите визу и налоговую стратегию с профессионалом.",
      "body": "Иммиграционный юрист и налоговый советник выстроят правильную стратегию до того, как вы определитесь со страной."
    },
    "checklist_prep": {
      "title": "Документы, переводы, нотариус — пусть этим займётся специалист.",
      "body": "Консультант или юрист управляет документооборотом и не даст ничему потеряться."
    },
    "checklist_logistics": {
      "title": "Апостили, перевозка, заявки в школу — полный turnkey.",
      "body": "Координатор переезда возьмёт на себя всю логистику от начала до конца."
    },
    "checklist_arrival": {
      "title": "Первые 2 недели: счёт, регистрация, врач.",
      "body": "Банковский советник и страховой брокер помогут подготовиться заранее и быстро встать на ноги."
    },
    "checklist_settle": {
      "title": "Найдите постоянного бухгалтера для отчётности и ВНЖ.",
      "body": "Местный налоговый бухгалтер закроет все требования по соответствию — вам остаётся только обустраиваться."
    }
  },
  "career": {
    "holding": {
      "meta": {
        "title": "Карьерная релокация — скоро · Lodestar",
        "description": "Строим вектор карьерной релокации в lodestar.place: разбор рынка труда по странам, визовые пути для квалифицированных мигрантов, реальные сроки, доступ к консультанту. Оставь email — напишем, когда первая страна выйдет."
      },
      "eyebrow": "Скоро",
      "title": "Карьерная релокация — осознанно.",
      "intro": "Карьерный переезд — это не лайфстайл. Для многих это выбор страны, где строить следующие 5–10 лет: спонсорский найм, виза для квалифицированных мигрантов, зарплата, которая действительно растёт. Строим этот вектор сейчас — поверх тех стран, которые уже покрыты в Lodestar.",
      "coming": {
        "title": "Что готовится",
        "i1": "Разбор рынка труда по каждой стране: глубина рынка, английский на работе, типовые зарплаты senior-уровня.",
        "i2": "Сравнение визовых путей для квалифицированных мигрантов — что работает для какого паспорта.",
        "i3": "Реальные сроки от реальных кандидатов: сколько на самом деле занимает получение оффера.",
        "i4": "Прямой доступ к консультанту по карьерной релокации для вашего конкретного переезда."
      },
      "notify": {
        "title": "Сообщить, когда будет готово",
        "body": "Напишем письмо, когда первая страна выйдет. Без спама, отписаться в один клик.",
        "placeholder": "ваш@email.com",
        "cta": "Сообщить",
        "submitting": "Отправляем…",
        "confirm": "Записали — напишем.",
        "micro": "Одно письмо, когда фича запустится. Ничего больше."
      },
      "consultant": {
        "title": "Уже в процессе?",
        "body": "Если карьерная релокация уже идёт и нужно обсудить конкретный оффер, спонсорство или процесс найма в стране — оставьте заявку, мы свяжемся.",
        "cta": "Поговорить с консультантом"
      }
    }
  },
  "report": {
    "pageTitle": "Ваш отчёт о релокации — Lodestar",
    "pageDescription": "Персональный отчёт о релокации, собранный из ваших ответов в квизе.",
    "kicker": "Персональный отчёт о релокации",
    "title": "Где вам будет хорошо — и как туда добраться",
    "loading": "Собираем ваш отчёт…",
    "decodeError": "Не удалось восстановить снимок ваших ответов для этого отчёта. Напишите на hello@lodestar.place — починим вручную.",
    "notFoundTitle": "Отчёт не найден",
    "notFoundText": "Ссылка неверна или устарела. Проверьте ссылку из письма-квитанции или напишите на hello@lodestar.place.",
    "refundedTitle": "По этой покупке оформлен возврат",
    "refundedText": "Ссылка на отчёт больше не активна. Если это ошибка — напишите на hello@lodestar.place.",
    "pendingTitle": "Завершаем оплату…",
    "pendingText": "Платёжный провайдер подтверждает заказ — обычно это занимает несколько секунд. Страница обновится сама.",
    "pendingStuckText": "Подтверждение идёт дольше обычного. Сохраните эту ссылку — отчёт откроется, как только платёж пройдёт. Если за час ничего не изменится, напишите на hello@lodestar.place.",
    "toolbarHint": "Эта ссылка — ваша, добавьте в закладки. Отчёт собирается из живых данных при каждом открытии.",
    "downloadPdf": "Сохранить в PDF",
    "compareTitle": "Ваша тройка лидеров бок о бок",
    "compareDim": "Ось",
    "methodology": "Оценки соединяют ваши ответы в квизе с данными по странам (визовые программы, налоговые режимы, налоги на недвижимость, владение машиной, отношение к паспорту), которые ведёт редакция Lodestar. Проценты — это соответствие ИМЕННО вашим ответам, а не абсолютная оценка страны.",
    "disclaimer": "Отчёт — это ориентир, а не юридическая, налоговая или иммиграционная консультация. Правила меняются: перед действиями проверяйте суммы и сроки в официальных источниках или у лицензированного специалиста.",
    "band": {
      "excellent": "Отличное совпадение",
      "strong": "Сильное совпадение",
      "fair": "Умеренное совпадение",
      "weak": "Слабое совпадение"
    },
    "whyFits": "Почему вам подходит",
    "watchOut": "На что обратить внимание",
    "dimsTitle": "Совпадение по осям",
    "visaPath": "Ваш самый сильный визовый путь",
    "visaIncomeFloor": "минимальный доход €{{amount}}/мес",
    "taxes": "Подоходный налог",
    "taxPit": "НДФЛ до",
    "taxRegime": "Спецрежим:",
    "property": "Налоги на недвижимость",
    "car": "Владение машиной",
    "perMonth": "мес",
    "passportNote": "Примечание по паспорту",
    "planTitle": "Ваши первые 12 месяцев — этапы",
    "planStartsWith": "начинается с",
    "guideLink": "Читать полный гид: {{name}}",
    "checklistLink": "Открыть интерактивный чеклист",
    "upsell": {
      "title": "Превратите этот результат в персональный отчёт о релокации",
      "subtitle": "Подробный документ по вашим топ-3 странам, собранный из ваших ответов. Час консультанта по релокации стоит от €100; это — подготовленная версия такого часа.",
      "bullet1": "Визовые пути под ваш паспорт — с порогами дохода",
      "bullet2": "Налоговая картина вашей ситуации: ставки, спецрежимы, заметки о соглашениях",
      "bullet3": "Бюджет первого года: налоги на жильё, машина, цифры за каждым процентом",
      "bullet4": "План действий на 12 месяцев по каждой стране + постоянная ссылка, готовая к PDF",
      "cta": "Получить отчёт — €29",
      "loading": "Открываем оплату…",
      "note": "Разовый платёж · мгновенный доступ · постоянная ссылка",
      "error": "Оплата не открылась — попробуйте ещё раз.",
      "previewCta": "Посмотреть превью отчёта — бесплатно"
    },
    "locked": {
      "title": "Откройте полный отчёт",
      "subtitle": "Вы увидели, как выглядит ваша страна №1. Цифры, которые превращают «куда» в «как», и две другие страны — в полном документе. Час консультанта по релокации стоит от €100; это подготовленная версия такого часа.",
      "factHint": "Порог дохода · налоги · бюджет · план — в отчёте",
      "unlock1": "Все три страны целиком — не только №1",
      "unlock2": "Точный визовый путь и месячный порог дохода под ваш паспорт",
      "unlock3": "Налоговый режим, расходы на жильё и авто — бюджет первого года в цифрах",
      "unlock4": "План на 12 месяцев по каждой стране + сравнение бок о бок",
      "unlock5": "Постоянная ссылка, готовая к печати в PDF"
    },
    "preview": {
      "pageTitle": "Превью отчёта о релокации — Lodestar",
      "pageDescription": "Бесплатное превью персонального отчёта о релокации, собранного из ваших ответов.",
      "banner": "Бесплатное превью · это ваша страна №1 — откройте все три ниже"
    },
    "seoCta": {
      "title": "А {{country}} — точно ваш лучший вариант?",
      "subtitle": "Пройдите двухминутный квиз и узнайте, как {{country}} сравнивается с остальными под вашу ситуацию — затем получите персональный отчёт по топ-3 с визовыми путями, налоговой картиной и бюджетом первого года.",
      "cta": "Подобрать страны под меня →",
      "note": "Квиз бесплатно · отчёт €29 · мгновенный доступ"
    }
  },
  "refund": {
    "back": "← Назад",
    "title": "Политика возврата",
    "updated": "Обновлено: {{date}}",
    "intro": "«Персональный отчёт о релокации» — цифровой продукт. Он формируется из ваших ответов в квизе и сразу выдаётся в виде личной ссылки, как только подтверждается оплата.",
    "s1": {
      "title": "1. Мгновенная выдача и ваше согласие",
      "body": "Покупая отчёт, вы просите выдать его немедленно и соглашаетесь на это. По законодательству ЕС о защите потребителей 14-дневное право на отказ для цифрового контента прекращается с началом выдачи — для этого продукта это момент, когда создаётся ваша ссылка на отчёт."
    },
    "s2": {
      "title": "2. Когда мы возвращаем деньги полностью",
      "lead": "Мы вернём вам деньги полностью, если:",
      "i1": "с вас списали оплату, но доступ к отчёту так и не появился (техническая ошибка с нашей стороны);",
      "i2": "с вас списали дважды за один заказ или списали по ошибке;",
      "i3": "отчёт не сформировался, оказался пустым или повреждённым, и мы не смогли это исправить.",
      "how": "Напишите нам на hello@lodestar.place в течение 14 дней после покупки с номером заказа — и мы всё решим."
    },
    "s3": {
      "title": "3. Когда возврат невозможен",
      "body": "Поскольку отчёт — это цифровой контент, который нельзя «вернуть», мы не можем оформить возврат «передумал» после того, как отчёт выдан и открыт. Если с самим отчётом что-то не так — сообщите нам, см. раздел 2."
    },
    "s4": {
      "title": "4. Как проходит возврат",
      "body": "Lemon Squeezy — наш Merchant of Record. Одобренные возвраты приходят на исходный способ оплаты через Lemon Squeezy, обычно в течение 5–10 рабочих дней."
    },
    "s5": {
      "title": "5. Контакты",
      "before": "Вопросы об оплате или возврате? Напишите на ",
      "email": "hello@lodestar.place",
      "after": " — ответим в течение пары рабочих дней."
    }
  },
  "reportLanding": {
    "metaTitle": "Персональный отчёт о релокации — Lodestar",
    "metaDescription": "Подробный отчёт за €29 по вашим топ-3 странам, собранный из ваших ответов в квизе: визовые пути, налоги, бюджет первого года и план на 12 месяцев.",
    "eyebrow": "Персональный отчёт о релокации",
    "h1": "Ваш переезд, разложенный по странам",
    "sub": "Подробный отчёт по трём странам, которые подходят вам лучше всего, собранный из ваших ответов в квизе. Все цифры за решением — в одном документе, который останется у вас навсегда.",
    "price": "€29 · разово · мгновенный доступ",
    "includesTitle": "Что внутри",
    "b1": "Визовые пути под ваш паспорт — с порогами дохода по каждому",
    "b2": "Налоговая картина вашей ситуации: ставки, спецрежимы, заметки о соглашениях",
    "b3": "Бюджет первого года: налоги на недвижимость, машина, цифры за каждым процентом",
    "b4": "План действий на 12 месяцев по каждой стране и постоянная ссылка, готовая к PDF",
    "howTitle": "Как это работает",
    "h1step": "Пройдите квиз за 2 минуты",
    "h1body": "Ответьте на вопросы о климате, бюджете, паспорте, семье и приоритетах.",
    "h2step": "Посмотрите рейтинг стран",
    "h2body": "Мы оцениваем 31 страну по вашим ответам и показываем лучшие совпадения — бесплатно.",
    "h3step": "Откройте полный отчёт",
    "h3body": "Превратите результат в подробный документ по топ-3 странам за €29.",
    "premade": "Отчёт формируется автоматически в момент покупки — без ожидания, без звонка, без участия человека. Это готовый цифровой продукт, а не консультация.",
    "cta": "Пройти квиз за 2 минуты →",
    "policiesLead": "Покупая, вы соглашаетесь с нашими",
    "terms": "Условиями",
    "refund": "Политикой возврата",
    "privacy": "Конфиденциальностью"
  },
  "annotations": {
    "add": "Добавить заметку",
    "cancelHint": "Нажмите ещё раз, чтобы отменить",
    "delete": "Удалить",
    "deleteConfirm": "Удалить эту заметку?",
    "placeholder": "Ваша заметка…",
    "placing": "Нажмите на карту, чтобы разместить…",
    "save": "Сохранить",
    "saving": "Сохраняем…",
    "startHint": "Нажмите в любом месте карты, чтобы добавить заметку",
    "toolbar": "Заметки"
  },
  "close": "Закрыть",
  "common": {
    "cancel": "Отмена",
    "close": "Закрыть"
  },
  "district": {
    "kind": {
      "cc": "Коммунитарный округ",
      "sll": "Локальная система занятости (SLL)",
      "ca": "Сельскохозяйственная комарка",
      "concelho": "Муниципалитет"
    }
  }
}
